var pt = Object.defineProperty;
var gt = (r, i, e) => i in r ? pt(r, i, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[i] = e;
var ze = (r, i, e) => (gt(r, typeof i != "symbol" ? i + "" : i, e), e);
import ot, { Component as mt } from "react";
function vt(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var Ln = { exports: {} }, sn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qn;
function ht() {
  if (qn)
    return sn;
  qn = 1;
  var r = ot, i = Symbol.for("react.element"), e = Symbol.for("react.fragment"), f = Object.prototype.hasOwnProperty, v = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function E(m, D, N) {
    var C, x = {}, L = null, q = null;
    N !== void 0 && (L = "" + N), D.key !== void 0 && (L = "" + D.key), D.ref !== void 0 && (q = D.ref);
    for (C in D)
      f.call(D, C) && !l.hasOwnProperty(C) && (x[C] = D[C]);
    if (m && m.defaultProps)
      for (C in D = m.defaultProps, D)
        x[C] === void 0 && (x[C] = D[C]);
    return { $$typeof: i, type: m, key: L, ref: q, props: x, _owner: v.current };
  }
  return sn.Fragment = e, sn.jsx = E, sn.jsxs = E, sn;
}
var fn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vn;
function yt() {
  return Vn || (Vn = 1, process.env.NODE_ENV !== "production" && function() {
    var r = ot, i = Symbol.for("react.element"), e = Symbol.for("react.portal"), f = Symbol.for("react.fragment"), v = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), E = Symbol.for("react.provider"), m = Symbol.for("react.context"), D = Symbol.for("react.forward_ref"), N = Symbol.for("react.suspense"), C = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), L = Symbol.for("react.lazy"), q = Symbol.for("react.offscreen"), ie = Symbol.iterator, T = "@@iterator";
    function ee(a) {
      if (a === null || typeof a != "object")
        return null;
      var s = ie && a[ie] || a[T];
      return typeof s == "function" ? s : null;
    }
    var te = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function B(a) {
      {
        for (var s = arguments.length, g = new Array(s > 1 ? s - 1 : 0), _ = 1; _ < s; _++)
          g[_ - 1] = arguments[_];
        Z("error", a, g);
      }
    }
    function Z(a, s, g) {
      {
        var _ = te.ReactDebugCurrentFrame, V = _.getStackAddendum();
        V !== "" && (s += "%s", g = g.concat([V]));
        var X = g.map(function(U) {
          return String(U);
        });
        X.unshift("Warning: " + s), Function.prototype.apply.call(console[a], console, X);
      }
    }
    var Q = !1, y = !1, fe = !1, Me = !1, Te = !1, Re;
    Re = Symbol.for("react.module.reference");
    function Pe(a) {
      return !!(typeof a == "string" || typeof a == "function" || a === f || a === l || Te || a === v || a === N || a === C || Me || a === q || Q || y || fe || typeof a == "object" && a !== null && (a.$$typeof === L || a.$$typeof === x || a.$$typeof === E || a.$$typeof === m || a.$$typeof === D || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      a.$$typeof === Re || a.getModuleId !== void 0));
    }
    function Ye(a, s, g) {
      var _ = a.displayName;
      if (_)
        return _;
      var V = s.displayName || s.name || "";
      return V !== "" ? g + "(" + V + ")" : g;
    }
    function ke(a) {
      return a.displayName || "Context";
    }
    function oe(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && B("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case f:
          return "Fragment";
        case e:
          return "Portal";
        case l:
          return "Profiler";
        case v:
          return "StrictMode";
        case N:
          return "Suspense";
        case C:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case m:
            var s = a;
            return ke(s) + ".Consumer";
          case E:
            var g = a;
            return ke(g._context) + ".Provider";
          case D:
            return Ye(a, a.render, "ForwardRef");
          case x:
            var _ = a.displayName || null;
            return _ !== null ? _ : oe(a.type) || "Memo";
          case L: {
            var V = a, X = V._payload, U = V._init;
            try {
              return oe(U(X));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var le = Object.assign, _e = 0, ge, xe, Ie, je, c, b, F;
    function A() {
    }
    A.__reactDisabledLog = !0;
    function R() {
      {
        if (_e === 0) {
          ge = console.log, xe = console.info, Ie = console.warn, je = console.error, c = console.group, b = console.groupCollapsed, F = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: A,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        _e++;
      }
    }
    function Y() {
      {
        if (_e--, _e === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: le({}, a, {
              value: ge
            }),
            info: le({}, a, {
              value: xe
            }),
            warn: le({}, a, {
              value: Ie
            }),
            error: le({}, a, {
              value: je
            }),
            group: le({}, a, {
              value: c
            }),
            groupCollapsed: le({}, a, {
              value: b
            }),
            groupEnd: le({}, a, {
              value: F
            })
          });
        }
        _e < 0 && B("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var O = te.ReactCurrentDispatcher, P;
    function k(a, s, g) {
      {
        if (P === void 0)
          try {
            throw Error();
          } catch (V) {
            var _ = V.stack.trim().match(/\n( *(at )?)/);
            P = _ && _[1] || "";
          }
        return `
` + P + a;
      }
    }
    var W = !1, H;
    {
      var se = typeof WeakMap == "function" ? WeakMap : Map;
      H = new se();
    }
    function p(a, s) {
      if (!a || W)
        return "";
      {
        var g = H.get(a);
        if (g !== void 0)
          return g;
      }
      var _;
      W = !0;
      var V = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var X;
      X = O.current, O.current = null, R();
      try {
        if (s) {
          var U = function() {
            throw Error();
          };
          if (Object.defineProperty(U.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(U, []);
            } catch (De) {
              _ = De;
            }
            Reflect.construct(a, [], U);
          } else {
            try {
              U.call();
            } catch (De) {
              _ = De;
            }
            a.call(U.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (De) {
            _ = De;
          }
          a();
        }
      } catch (De) {
        if (De && _ && typeof De.stack == "string") {
          for (var $ = De.stack.split(`
`), ce = _.stack.split(`
`), re = $.length - 1, ae = ce.length - 1; re >= 1 && ae >= 0 && $[re] !== ce[ae]; )
            ae--;
          for (; re >= 1 && ae >= 0; re--, ae--)
            if ($[re] !== ce[ae]) {
              if (re !== 1 || ae !== 1)
                do
                  if (re--, ae--, ae < 0 || $[re] !== ce[ae]) {
                    var be = `
` + $[re].replace(" at new ", " at ");
                    return a.displayName && be.includes("<anonymous>") && (be = be.replace("<anonymous>", a.displayName)), typeof a == "function" && H.set(a, be), be;
                  }
                while (re >= 1 && ae >= 0);
              break;
            }
        }
      } finally {
        W = !1, O.current = X, Y(), Error.prepareStackTrace = V;
      }
      var Je = a ? a.displayName || a.name : "", qe = Je ? k(Je) : "";
      return typeof a == "function" && H.set(a, qe), qe;
    }
    function ye(a, s, g) {
      return p(a, !1);
    }
    function Ne(a) {
      var s = a.prototype;
      return !!(s && s.isReactComponent);
    }
    function Ae(a, s, g) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return p(a, Ne(a));
      if (typeof a == "string")
        return k(a);
      switch (a) {
        case N:
          return k("Suspense");
        case C:
          return k("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case D:
            return ye(a.render);
          case x:
            return Ae(a.type, s, g);
          case L: {
            var _ = a, V = _._payload, X = _._init;
            try {
              return Ae(X(V), s, g);
            } catch {
            }
          }
        }
      return "";
    }
    var $e = Object.prototype.hasOwnProperty, Ze = {}, Qe = te.ReactDebugCurrentFrame;
    function Fe(a) {
      if (a) {
        var s = a._owner, g = Ae(a.type, a._source, s ? s.type : null);
        Qe.setExtraStackFrame(g);
      } else
        Qe.setExtraStackFrame(null);
    }
    function Dn(a, s, g, _, V) {
      {
        var X = Function.call.bind($e);
        for (var U in a)
          if (X(a, U)) {
            var $ = void 0;
            try {
              if (typeof a[U] != "function") {
                var ce = Error((_ || "React class") + ": " + g + " type `" + U + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[U] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ce.name = "Invariant Violation", ce;
              }
              $ = a[U](s, U, _, g, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (re) {
              $ = re;
            }
            $ && !($ instanceof Error) && (Fe(V), B("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", _ || "React class", g, U, typeof $), Fe(null)), $ instanceof Error && !($.message in Ze) && (Ze[$.message] = !0, Fe(V), B("Failed %s type: %s", g, $.message), Fe(null));
          }
      }
    }
    var Cn = Array.isArray;
    function Be(a) {
      return Cn(a);
    }
    function en(a) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, g = s && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return g;
      }
    }
    function dn(a) {
      try {
        return Ue(a), !1;
      } catch {
        return !0;
      }
    }
    function Ue(a) {
      return "" + a;
    }
    function pn(a) {
      if (dn(a))
        return B("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", en(a)), Ue(a);
    }
    var Le = te.ReactCurrentOwner, wn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, nn, gn, tn;
    tn = {};
    function mn(a) {
      if ($e.call(a, "ref")) {
        var s = Object.getOwnPropertyDescriptor(a, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return a.ref !== void 0;
    }
    function En(a) {
      if ($e.call(a, "key")) {
        var s = Object.getOwnPropertyDescriptor(a, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return a.key !== void 0;
    }
    function Mn(a, s) {
      if (typeof a.ref == "string" && Le.current && s && Le.current.stateNode !== s) {
        var g = oe(Le.current.type);
        tn[g] || (B('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', oe(Le.current.type), a.ref), tn[g] = !0);
      }
    }
    function ne(a, s) {
      {
        var g = function() {
          nn || (nn = !0, B("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        g.isReactWarning = !0, Object.defineProperty(a, "key", {
          get: g,
          configurable: !0
        });
      }
    }
    function rn(a, s) {
      {
        var g = function() {
          gn || (gn = !0, B("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        g.isReactWarning = !0, Object.defineProperty(a, "ref", {
          get: g,
          configurable: !0
        });
      }
    }
    var an = function(a, s, g, _, V, X, U) {
      var $ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: i,
        // Built-in properties that belong on the element
        type: a,
        key: s,
        ref: g,
        props: U,
        // Record the component responsible for creating this element.
        _owner: X
      };
      return $._store = {}, Object.defineProperty($._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty($, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: _
      }), Object.defineProperty($, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: V
      }), Object.freeze && (Object.freeze($.props), Object.freeze($)), $;
    };
    function Tn(a, s, g, _, V) {
      {
        var X, U = {}, $ = null, ce = null;
        g !== void 0 && (pn(g), $ = "" + g), En(s) && (pn(s.key), $ = "" + s.key), mn(s) && (ce = s.ref, Mn(s, V));
        for (X in s)
          $e.call(s, X) && !wn.hasOwnProperty(X) && (U[X] = s[X]);
        if (a && a.defaultProps) {
          var re = a.defaultProps;
          for (X in re)
            U[X] === void 0 && (U[X] = re[X]);
        }
        if ($ || ce) {
          var ae = typeof a == "function" ? a.displayName || a.name || "Unknown" : a;
          $ && ne(U, ae), ce && rn(U, ae);
        }
        return an(a, $, ce, V, _, Le.current, U);
      }
    }
    var He = te.ReactCurrentOwner, Ke = te.ReactDebugCurrentFrame;
    function de(a) {
      if (a) {
        var s = a._owner, g = Ae(a.type, a._source, s ? s.type : null);
        Ke.setExtraStackFrame(g);
      } else
        Ke.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function un(a) {
      return typeof a == "object" && a !== null && a.$$typeof === i;
    }
    function n() {
      {
        if (He.current) {
          var a = oe(He.current.type);
          if (a)
            return `

Check the render method of \`` + a + "`.";
        }
        return "";
      }
    }
    function t(a) {
      {
        if (a !== void 0) {
          var s = a.fileName.replace(/^.*[\\\/]/, ""), g = a.lineNumber;
          return `

Check your code at ` + s + ":" + g + ".";
        }
        return "";
      }
    }
    var o = {};
    function u(a) {
      {
        var s = n();
        if (!s) {
          var g = typeof a == "string" ? a : a.displayName || a.name;
          g && (s = `

Check the top-level render call using <` + g + ">.");
        }
        return s;
      }
    }
    function d(a, s) {
      {
        if (!a._store || a._store.validated || a.key != null)
          return;
        a._store.validated = !0;
        var g = u(s);
        if (o[g])
          return;
        o[g] = !0;
        var _ = "";
        a && a._owner && a._owner !== He.current && (_ = " It was passed a child from " + oe(a._owner.type) + "."), de(a), B('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', g, _), de(null);
      }
    }
    function h(a, s) {
      {
        if (typeof a != "object")
          return;
        if (Be(a))
          for (var g = 0; g < a.length; g++) {
            var _ = a[g];
            un(_) && d(_, s);
          }
        else if (un(a))
          a._store && (a._store.validated = !0);
        else if (a) {
          var V = ee(a);
          if (typeof V == "function" && V !== a.entries)
            for (var X = V.call(a), U; !(U = X.next()).done; )
              un(U.value) && d(U.value, s);
        }
      }
    }
    function I(a) {
      {
        var s = a.type;
        if (s == null || typeof s == "string")
          return;
        var g;
        if (typeof s == "function")
          g = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === D || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === x))
          g = s.propTypes;
        else
          return;
        if (g) {
          var _ = oe(s);
          Dn(g, a.props, "prop", _, a);
        } else if (s.PropTypes !== void 0 && !on) {
          on = !0;
          var V = oe(s);
          B("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", V || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && B("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function M(a) {
      {
        for (var s = Object.keys(a.props), g = 0; g < s.length; g++) {
          var _ = s[g];
          if (_ !== "children" && _ !== "key") {
            de(a), B("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", _), de(null);
            break;
          }
        }
        a.ref !== null && (de(a), B("Invalid attribute `ref` supplied to `React.Fragment`."), de(null));
      }
    }
    var j = {};
    function w(a, s, g, _, V, X) {
      {
        var U = Pe(a);
        if (!U) {
          var $ = "";
          (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && ($ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ce = t(V);
          ce ? $ += ce : $ += n();
          var re;
          a === null ? re = "null" : Be(a) ? re = "array" : a !== void 0 && a.$$typeof === i ? (re = "<" + (oe(a.type) || "Unknown") + " />", $ = " Did you accidentally export a JSX literal instead of a component?") : re = typeof a, B("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", re, $);
        }
        var ae = Tn(a, s, g, V, X);
        if (ae == null)
          return ae;
        if (U) {
          var be = s.children;
          if (be !== void 0)
            if (_)
              if (Be(be)) {
                for (var Je = 0; Je < be.length; Je++)
                  h(be[Je], a);
                Object.freeze && Object.freeze(be);
              } else
                B("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              h(be, a);
        }
        if ($e.call(s, "key")) {
          var qe = oe(a), De = Object.keys(s).filter(function(dt) {
            return dt !== "key";
          }), _n = De.length > 0 ? "{key: someKey, " + De.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!j[qe + _n]) {
            var lt = De.length > 0 ? "{" + De.join(": ..., ") + ": ...}" : "{}";
            B(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, _n, qe, lt, qe), j[qe + _n] = !0;
          }
        }
        return a === f ? M(ae) : I(ae), ae;
      }
    }
    function S(a, s, g) {
      return w(a, s, g, !0);
    }
    function G(a, s, g) {
      return w(a, s, g, !1);
    }
    var Se = G, me = S;
    fn.Fragment = f, fn.jsx = Se, fn.jsxs = me;
  }()), fn;
}
process.env.NODE_ENV === "production" ? Ln.exports = ht() : Ln.exports = yt();
var bt = Ln.exports;
const Bn = bt.jsx;
var Hn = { exports: {} }, vn = { exports: {} }, J = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kn;
function Dt() {
  if (Kn)
    return J;
  Kn = 1;
  var r = typeof Symbol == "function" && Symbol.for, i = r ? Symbol.for("react.element") : 60103, e = r ? Symbol.for("react.portal") : 60106, f = r ? Symbol.for("react.fragment") : 60107, v = r ? Symbol.for("react.strict_mode") : 60108, l = r ? Symbol.for("react.profiler") : 60114, E = r ? Symbol.for("react.provider") : 60109, m = r ? Symbol.for("react.context") : 60110, D = r ? Symbol.for("react.async_mode") : 60111, N = r ? Symbol.for("react.concurrent_mode") : 60111, C = r ? Symbol.for("react.forward_ref") : 60112, x = r ? Symbol.for("react.suspense") : 60113, L = r ? Symbol.for("react.suspense_list") : 60120, q = r ? Symbol.for("react.memo") : 60115, ie = r ? Symbol.for("react.lazy") : 60116, T = r ? Symbol.for("react.block") : 60121, ee = r ? Symbol.for("react.fundamental") : 60117, te = r ? Symbol.for("react.responder") : 60118, B = r ? Symbol.for("react.scope") : 60119;
  function Z(y) {
    if (typeof y == "object" && y !== null) {
      var fe = y.$$typeof;
      switch (fe) {
        case i:
          switch (y = y.type, y) {
            case D:
            case N:
            case f:
            case l:
            case v:
            case x:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case m:
                case C:
                case ie:
                case q:
                case E:
                  return y;
                default:
                  return fe;
              }
          }
        case e:
          return fe;
      }
    }
  }
  function Q(y) {
    return Z(y) === N;
  }
  return J.AsyncMode = D, J.ConcurrentMode = N, J.ContextConsumer = m, J.ContextProvider = E, J.Element = i, J.ForwardRef = C, J.Fragment = f, J.Lazy = ie, J.Memo = q, J.Portal = e, J.Profiler = l, J.StrictMode = v, J.Suspense = x, J.isAsyncMode = function(y) {
    return Q(y) || Z(y) === D;
  }, J.isConcurrentMode = Q, J.isContextConsumer = function(y) {
    return Z(y) === m;
  }, J.isContextProvider = function(y) {
    return Z(y) === E;
  }, J.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === i;
  }, J.isForwardRef = function(y) {
    return Z(y) === C;
  }, J.isFragment = function(y) {
    return Z(y) === f;
  }, J.isLazy = function(y) {
    return Z(y) === ie;
  }, J.isMemo = function(y) {
    return Z(y) === q;
  }, J.isPortal = function(y) {
    return Z(y) === e;
  }, J.isProfiler = function(y) {
    return Z(y) === l;
  }, J.isStrictMode = function(y) {
    return Z(y) === v;
  }, J.isSuspense = function(y) {
    return Z(y) === x;
  }, J.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === f || y === N || y === l || y === v || y === x || y === L || typeof y == "object" && y !== null && (y.$$typeof === ie || y.$$typeof === q || y.$$typeof === E || y.$$typeof === m || y.$$typeof === C || y.$$typeof === ee || y.$$typeof === te || y.$$typeof === B || y.$$typeof === T);
  }, J.typeOf = Z, J;
}
var z = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jn;
function Ct() {
  return Jn || (Jn = 1, process.env.NODE_ENV !== "production" && function() {
    var r = typeof Symbol == "function" && Symbol.for, i = r ? Symbol.for("react.element") : 60103, e = r ? Symbol.for("react.portal") : 60106, f = r ? Symbol.for("react.fragment") : 60107, v = r ? Symbol.for("react.strict_mode") : 60108, l = r ? Symbol.for("react.profiler") : 60114, E = r ? Symbol.for("react.provider") : 60109, m = r ? Symbol.for("react.context") : 60110, D = r ? Symbol.for("react.async_mode") : 60111, N = r ? Symbol.for("react.concurrent_mode") : 60111, C = r ? Symbol.for("react.forward_ref") : 60112, x = r ? Symbol.for("react.suspense") : 60113, L = r ? Symbol.for("react.suspense_list") : 60120, q = r ? Symbol.for("react.memo") : 60115, ie = r ? Symbol.for("react.lazy") : 60116, T = r ? Symbol.for("react.block") : 60121, ee = r ? Symbol.for("react.fundamental") : 60117, te = r ? Symbol.for("react.responder") : 60118, B = r ? Symbol.for("react.scope") : 60119;
    function Z(p) {
      return typeof p == "string" || typeof p == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      p === f || p === N || p === l || p === v || p === x || p === L || typeof p == "object" && p !== null && (p.$$typeof === ie || p.$$typeof === q || p.$$typeof === E || p.$$typeof === m || p.$$typeof === C || p.$$typeof === ee || p.$$typeof === te || p.$$typeof === B || p.$$typeof === T);
    }
    function Q(p) {
      if (typeof p == "object" && p !== null) {
        var ye = p.$$typeof;
        switch (ye) {
          case i:
            var Ne = p.type;
            switch (Ne) {
              case D:
              case N:
              case f:
              case l:
              case v:
              case x:
                return Ne;
              default:
                var Ae = Ne && Ne.$$typeof;
                switch (Ae) {
                  case m:
                  case C:
                  case ie:
                  case q:
                  case E:
                    return Ae;
                  default:
                    return ye;
                }
            }
          case e:
            return ye;
        }
      }
    }
    var y = D, fe = N, Me = m, Te = E, Re = i, Pe = C, Ye = f, ke = ie, oe = q, le = e, _e = l, ge = v, xe = x, Ie = !1;
    function je(p) {
      return Ie || (Ie = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), c(p) || Q(p) === D;
    }
    function c(p) {
      return Q(p) === N;
    }
    function b(p) {
      return Q(p) === m;
    }
    function F(p) {
      return Q(p) === E;
    }
    function A(p) {
      return typeof p == "object" && p !== null && p.$$typeof === i;
    }
    function R(p) {
      return Q(p) === C;
    }
    function Y(p) {
      return Q(p) === f;
    }
    function O(p) {
      return Q(p) === ie;
    }
    function P(p) {
      return Q(p) === q;
    }
    function k(p) {
      return Q(p) === e;
    }
    function W(p) {
      return Q(p) === l;
    }
    function H(p) {
      return Q(p) === v;
    }
    function se(p) {
      return Q(p) === x;
    }
    z.AsyncMode = y, z.ConcurrentMode = fe, z.ContextConsumer = Me, z.ContextProvider = Te, z.Element = Re, z.ForwardRef = Pe, z.Fragment = Ye, z.Lazy = ke, z.Memo = oe, z.Portal = le, z.Profiler = _e, z.StrictMode = ge, z.Suspense = xe, z.isAsyncMode = je, z.isConcurrentMode = c, z.isContextConsumer = b, z.isContextProvider = F, z.isElement = A, z.isForwardRef = R, z.isFragment = Y, z.isLazy = O, z.isMemo = P, z.isPortal = k, z.isProfiler = W, z.isStrictMode = H, z.isSuspense = se, z.isValidElementType = Z, z.typeOf = Q;
  }()), z;
}
var zn;
function ut() {
  return zn || (zn = 1, process.env.NODE_ENV === "production" ? vn.exports = Dt() : vn.exports = Ct()), vn.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var xn, Gn;
function wt() {
  if (Gn)
    return xn;
  Gn = 1;
  var r = Object.getOwnPropertySymbols, i = Object.prototype.hasOwnProperty, e = Object.prototype.propertyIsEnumerable;
  function f(l) {
    if (l == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(l);
  }
  function v() {
    try {
      if (!Object.assign)
        return !1;
      var l = new String("abc");
      if (l[5] = "de", Object.getOwnPropertyNames(l)[0] === "5")
        return !1;
      for (var E = {}, m = 0; m < 10; m++)
        E["_" + String.fromCharCode(m)] = m;
      var D = Object.getOwnPropertyNames(E).map(function(C) {
        return E[C];
      });
      if (D.join("") !== "0123456789")
        return !1;
      var N = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(C) {
        N[C] = C;
      }), Object.keys(Object.assign({}, N)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return xn = v() ? Object.assign : function(l, E) {
    for (var m, D = f(l), N, C = 1; C < arguments.length; C++) {
      m = Object(arguments[C]);
      for (var x in m)
        i.call(m, x) && (D[x] = m[x]);
      if (r) {
        N = r(m);
        for (var L = 0; L < N.length; L++)
          e.call(m, N[L]) && (D[N[L]] = m[N[L]]);
      }
    }
    return D;
  }, xn;
}
var Sn, Xn;
function Un() {
  if (Xn)
    return Sn;
  Xn = 1;
  var r = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Sn = r, Sn;
}
var On, Zn;
function st() {
  return Zn || (Zn = 1, On = Function.call.bind(Object.prototype.hasOwnProperty)), On;
}
var Pn, Qn;
function Et() {
  if (Qn)
    return Pn;
  Qn = 1;
  var r = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var i = Un(), e = {}, f = st();
    r = function(l) {
      var E = "Warning: " + l;
      typeof console < "u" && console.error(E);
      try {
        throw new Error(E);
      } catch {
      }
    };
  }
  function v(l, E, m, D, N) {
    if (process.env.NODE_ENV !== "production") {
      for (var C in l)
        if (f(l, C)) {
          var x;
          try {
            if (typeof l[C] != "function") {
              var L = Error(
                (D || "React class") + ": " + m + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw L.name = "Invariant Violation", L;
            }
            x = l[C](E, C, D, m, null, i);
          } catch (ie) {
            x = ie;
          }
          if (x && !(x instanceof Error) && r(
            (D || "React class") + ": type specification of " + m + " `" + C + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof x + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), x instanceof Error && !(x.message in e)) {
            e[x.message] = !0;
            var q = N ? N() : "";
            r(
              "Failed " + m + " type: " + x.message + (q ?? "")
            );
          }
        }
    }
  }
  return v.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (e = {});
  }, Pn = v, Pn;
}
var kn, et;
function Mt() {
  if (et)
    return kn;
  et = 1;
  var r = ut(), i = wt(), e = Un(), f = st(), v = Et(), l = function() {
  };
  process.env.NODE_ENV !== "production" && (l = function(m) {
    var D = "Warning: " + m;
    typeof console < "u" && console.error(D);
    try {
      throw new Error(D);
    } catch {
    }
  });
  function E() {
    return null;
  }
  return kn = function(m, D) {
    var N = typeof Symbol == "function" && Symbol.iterator, C = "@@iterator";
    function x(c) {
      var b = c && (N && c[N] || c[C]);
      if (typeof b == "function")
        return b;
    }
    var L = "<<anonymous>>", q = {
      array: te("array"),
      bigint: te("bigint"),
      bool: te("boolean"),
      func: te("function"),
      number: te("number"),
      object: te("object"),
      string: te("string"),
      symbol: te("symbol"),
      any: B(),
      arrayOf: Z,
      element: Q(),
      elementType: y(),
      instanceOf: fe,
      node: Pe(),
      objectOf: Te,
      oneOf: Me,
      oneOfType: Re,
      shape: ke,
      exact: oe
    };
    function ie(c, b) {
      return c === b ? c !== 0 || 1 / c === 1 / b : c !== c && b !== b;
    }
    function T(c, b) {
      this.message = c, this.data = b && typeof b == "object" ? b : {}, this.stack = "";
    }
    T.prototype = Error.prototype;
    function ee(c) {
      if (process.env.NODE_ENV !== "production")
        var b = {}, F = 0;
      function A(Y, O, P, k, W, H, se) {
        if (k = k || L, H = H || P, se !== e) {
          if (D) {
            var p = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw p.name = "Invariant Violation", p;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ye = k + ":" + P;
            !b[ye] && // Avoid spamming the console because they are often not actionable except for lib authors
            F < 3 && (l(
              "You are manually calling a React.PropTypes validation function for the `" + H + "` prop on `" + k + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), b[ye] = !0, F++);
          }
        }
        return O[P] == null ? Y ? O[P] === null ? new T("The " + W + " `" + H + "` is marked as required " + ("in `" + k + "`, but its value is `null`.")) : new T("The " + W + " `" + H + "` is marked as required in " + ("`" + k + "`, but its value is `undefined`.")) : null : c(O, P, k, W, H);
      }
      var R = A.bind(null, !1);
      return R.isRequired = A.bind(null, !0), R;
    }
    function te(c) {
      function b(F, A, R, Y, O, P) {
        var k = F[A], W = ge(k);
        if (W !== c) {
          var H = xe(k);
          return new T(
            "Invalid " + Y + " `" + O + "` of type " + ("`" + H + "` supplied to `" + R + "`, expected ") + ("`" + c + "`."),
            { expectedType: c }
          );
        }
        return null;
      }
      return ee(b);
    }
    function B() {
      return ee(E);
    }
    function Z(c) {
      function b(F, A, R, Y, O) {
        if (typeof c != "function")
          return new T("Property `" + O + "` of component `" + R + "` has invalid PropType notation inside arrayOf.");
        var P = F[A];
        if (!Array.isArray(P)) {
          var k = ge(P);
          return new T("Invalid " + Y + " `" + O + "` of type " + ("`" + k + "` supplied to `" + R + "`, expected an array."));
        }
        for (var W = 0; W < P.length; W++) {
          var H = c(P, W, R, Y, O + "[" + W + "]", e);
          if (H instanceof Error)
            return H;
        }
        return null;
      }
      return ee(b);
    }
    function Q() {
      function c(b, F, A, R, Y) {
        var O = b[F];
        if (!m(O)) {
          var P = ge(O);
          return new T("Invalid " + R + " `" + Y + "` of type " + ("`" + P + "` supplied to `" + A + "`, expected a single ReactElement."));
        }
        return null;
      }
      return ee(c);
    }
    function y() {
      function c(b, F, A, R, Y) {
        var O = b[F];
        if (!r.isValidElementType(O)) {
          var P = ge(O);
          return new T("Invalid " + R + " `" + Y + "` of type " + ("`" + P + "` supplied to `" + A + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return ee(c);
    }
    function fe(c) {
      function b(F, A, R, Y, O) {
        if (!(F[A] instanceof c)) {
          var P = c.name || L, k = je(F[A]);
          return new T("Invalid " + Y + " `" + O + "` of type " + ("`" + k + "` supplied to `" + R + "`, expected ") + ("instance of `" + P + "`."));
        }
        return null;
      }
      return ee(b);
    }
    function Me(c) {
      if (!Array.isArray(c))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? l(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : l("Invalid argument supplied to oneOf, expected an array.")), E;
      function b(F, A, R, Y, O) {
        for (var P = F[A], k = 0; k < c.length; k++)
          if (ie(P, c[k]))
            return null;
        var W = JSON.stringify(c, function(se, p) {
          var ye = xe(p);
          return ye === "symbol" ? String(p) : p;
        });
        return new T("Invalid " + Y + " `" + O + "` of value `" + String(P) + "` " + ("supplied to `" + R + "`, expected one of " + W + "."));
      }
      return ee(b);
    }
    function Te(c) {
      function b(F, A, R, Y, O) {
        if (typeof c != "function")
          return new T("Property `" + O + "` of component `" + R + "` has invalid PropType notation inside objectOf.");
        var P = F[A], k = ge(P);
        if (k !== "object")
          return new T("Invalid " + Y + " `" + O + "` of type " + ("`" + k + "` supplied to `" + R + "`, expected an object."));
        for (var W in P)
          if (f(P, W)) {
            var H = c(P, W, R, Y, O + "." + W, e);
            if (H instanceof Error)
              return H;
          }
        return null;
      }
      return ee(b);
    }
    function Re(c) {
      if (!Array.isArray(c))
        return process.env.NODE_ENV !== "production" && l("Invalid argument supplied to oneOfType, expected an instance of array."), E;
      for (var b = 0; b < c.length; b++) {
        var F = c[b];
        if (typeof F != "function")
          return l(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Ie(F) + " at index " + b + "."
          ), E;
      }
      function A(R, Y, O, P, k) {
        for (var W = [], H = 0; H < c.length; H++) {
          var se = c[H], p = se(R, Y, O, P, k, e);
          if (p == null)
            return null;
          p.data && f(p.data, "expectedType") && W.push(p.data.expectedType);
        }
        var ye = W.length > 0 ? ", expected one of type [" + W.join(", ") + "]" : "";
        return new T("Invalid " + P + " `" + k + "` supplied to " + ("`" + O + "`" + ye + "."));
      }
      return ee(A);
    }
    function Pe() {
      function c(b, F, A, R, Y) {
        return le(b[F]) ? null : new T("Invalid " + R + " `" + Y + "` supplied to " + ("`" + A + "`, expected a ReactNode."));
      }
      return ee(c);
    }
    function Ye(c, b, F, A, R) {
      return new T(
        (c || "React class") + ": " + b + " type `" + F + "." + A + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + R + "`."
      );
    }
    function ke(c) {
      function b(F, A, R, Y, O) {
        var P = F[A], k = ge(P);
        if (k !== "object")
          return new T("Invalid " + Y + " `" + O + "` of type `" + k + "` " + ("supplied to `" + R + "`, expected `object`."));
        for (var W in c) {
          var H = c[W];
          if (typeof H != "function")
            return Ye(R, Y, O, W, xe(H));
          var se = H(P, W, R, Y, O + "." + W, e);
          if (se)
            return se;
        }
        return null;
      }
      return ee(b);
    }
    function oe(c) {
      function b(F, A, R, Y, O) {
        var P = F[A], k = ge(P);
        if (k !== "object")
          return new T("Invalid " + Y + " `" + O + "` of type `" + k + "` " + ("supplied to `" + R + "`, expected `object`."));
        var W = i({}, F[A], c);
        for (var H in W) {
          var se = c[H];
          if (f(c, H) && typeof se != "function")
            return Ye(R, Y, O, H, xe(se));
          if (!se)
            return new T(
              "Invalid " + Y + " `" + O + "` key `" + H + "` supplied to `" + R + "`.\nBad object: " + JSON.stringify(F[A], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(c), null, "  ")
            );
          var p = se(P, H, R, Y, O + "." + H, e);
          if (p)
            return p;
        }
        return null;
      }
      return ee(b);
    }
    function le(c) {
      switch (typeof c) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !c;
        case "object":
          if (Array.isArray(c))
            return c.every(le);
          if (c === null || m(c))
            return !0;
          var b = x(c);
          if (b) {
            var F = b.call(c), A;
            if (b !== c.entries) {
              for (; !(A = F.next()).done; )
                if (!le(A.value))
                  return !1;
            } else
              for (; !(A = F.next()).done; ) {
                var R = A.value;
                if (R && !le(R[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function _e(c, b) {
      return c === "symbol" ? !0 : b ? b["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && b instanceof Symbol : !1;
    }
    function ge(c) {
      var b = typeof c;
      return Array.isArray(c) ? "array" : c instanceof RegExp ? "object" : _e(b, c) ? "symbol" : b;
    }
    function xe(c) {
      if (typeof c > "u" || c === null)
        return "" + c;
      var b = ge(c);
      if (b === "object") {
        if (c instanceof Date)
          return "date";
        if (c instanceof RegExp)
          return "regexp";
      }
      return b;
    }
    function Ie(c) {
      var b = xe(c);
      switch (b) {
        case "array":
        case "object":
          return "an " + b;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + b;
        default:
          return b;
      }
    }
    function je(c) {
      return !c.constructor || !c.constructor.name ? L : c.constructor.name;
    }
    return q.checkPropTypes = v, q.resetWarningCache = v.resetWarningCache, q.PropTypes = q, q;
  }, kn;
}
var Rn, nt;
function Tt() {
  if (nt)
    return Rn;
  nt = 1;
  var r = Un();
  function i() {
  }
  function e() {
  }
  return e.resetWarningCache = i, Rn = function() {
    function f(E, m, D, N, C, x) {
      if (x !== r) {
        var L = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw L.name = "Invariant Violation", L;
      }
    }
    f.isRequired = f;
    function v() {
      return f;
    }
    var l = {
      array: f,
      bigint: f,
      bool: f,
      func: f,
      number: f,
      object: f,
      string: f,
      symbol: f,
      any: f,
      arrayOf: v,
      element: f,
      elementType: f,
      instanceOf: v,
      node: f,
      objectOf: v,
      oneOf: v,
      oneOfType: v,
      shape: v,
      exact: v,
      checkPropTypes: e,
      resetWarningCache: i
    };
    return l.PropTypes = l, l;
  }, Rn;
}
if (process.env.NODE_ENV !== "production") {
  var _t = ut(), xt = !0;
  Hn.exports = Mt()(_t.isElement, xt);
} else
  Hn.exports = Tt()();
var St = Hn.exports;
const he = /* @__PURE__ */ vt(St);
var In = [
  "onChange",
  "onClose",
  "onDayCreate",
  "onDestroy",
  "onKeyDown",
  "onMonthChange",
  "onOpen",
  "onParseConfig",
  "onReady",
  "onValueUpdate",
  "onYearChange",
  "onPreCalendarPosition"
], Ge = {
  _disable: [],
  allowInput: !1,
  allowInvalidPreload: !1,
  altFormat: "F j, Y",
  altInput: !1,
  altInputClass: "form-control input",
  animate: typeof window == "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
  ariaDateFormat: "F j, Y",
  autoFillDefaultTime: !0,
  clickOpens: !0,
  closeOnSelect: !0,
  conjunction: ", ",
  dateFormat: "Y-m-d",
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: !1,
  enableSeconds: !1,
  enableTime: !1,
  errorHandler: function(r) {
    return typeof console < "u" && console.warn(r);
  },
  getWeek: function(r) {
    var i = new Date(r.getTime());
    i.setHours(0, 0, 0, 0), i.setDate(i.getDate() + 3 - (i.getDay() + 6) % 7);
    var e = new Date(i.getFullYear(), 0, 4);
    return 1 + Math.round(((i.getTime() - e.getTime()) / 864e5 - 3 + (e.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: !1,
  locale: "default",
  minuteIncrement: 5,
  mode: "single",
  monthSelectorType: "dropdown",
  nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
  noCalendar: !1,
  now: /* @__PURE__ */ new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: "auto",
  positionElement: void 0,
  prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
  shorthandCurrentMonth: !1,
  showMonths: 1,
  static: !1,
  time_24hr: !1,
  weekNumbers: !1,
  wrap: !1
}, ln = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  },
  months: {
    shorthand: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    longhand: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function(r) {
    var i = r % 100;
    if (i > 3 && i < 21)
      return "th";
    switch (i % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  },
  rangeSeparator: " to ",
  weekAbbreviation: "Wk",
  scrollTitle: "Scroll to increment",
  toggleTitle: "Click to toggle",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Year",
  monthAriaLabel: "Month",
  hourAriaLabel: "Hour",
  minuteAriaLabel: "Minute",
  time_24hr: !1
}, Ce = function(r, i) {
  return i === void 0 && (i = 2), ("000" + r).slice(i * -1);
}, Oe = function(r) {
  return r === !0 ? 1 : 0;
};
function tt(r, i) {
  var e;
  return function() {
    var f = this, v = arguments;
    clearTimeout(e), e = setTimeout(function() {
      return r.apply(f, v);
    }, i);
  };
}
var An = function(r) {
  return r instanceof Array ? r : [r];
};
function ve(r, i, e) {
  if (e === !0)
    return r.classList.add(i);
  r.classList.remove(i);
}
function K(r, i, e) {
  var f = window.document.createElement(r);
  return i = i || "", e = e || "", f.className = i, e !== void 0 && (f.textContent = e), f;
}
function hn(r) {
  for (; r.firstChild; )
    r.removeChild(r.firstChild);
}
function ft(r, i) {
  if (i(r))
    return r;
  if (r.parentNode)
    return ft(r.parentNode, i);
}
function yn(r, i) {
  var e = K("div", "numInputWrapper"), f = K("input", "numInput " + r), v = K("span", "arrowUp"), l = K("span", "arrowDown");
  if (navigator.userAgent.indexOf("MSIE 9.0") === -1 ? f.type = "number" : (f.type = "text", f.pattern = "\\d*"), i !== void 0)
    for (var E in i)
      f.setAttribute(E, i[E]);
  return e.appendChild(f), e.appendChild(v), e.appendChild(l), e;
}
function we(r) {
  try {
    if (typeof r.composedPath == "function") {
      var i = r.composedPath();
      return i[0];
    }
    return r.target;
  } catch {
    return r.target;
  }
}
var jn = function() {
}, bn = function(r, i, e) {
  return e.months[i ? "shorthand" : "longhand"][r];
}, Ot = {
  D: jn,
  F: function(r, i, e) {
    r.setMonth(e.months.longhand.indexOf(i));
  },
  G: function(r, i) {
    r.setHours((r.getHours() >= 12 ? 12 : 0) + parseFloat(i));
  },
  H: function(r, i) {
    r.setHours(parseFloat(i));
  },
  J: function(r, i) {
    r.setDate(parseFloat(i));
  },
  K: function(r, i, e) {
    r.setHours(r.getHours() % 12 + 12 * Oe(new RegExp(e.amPM[1], "i").test(i)));
  },
  M: function(r, i, e) {
    r.setMonth(e.months.shorthand.indexOf(i));
  },
  S: function(r, i) {
    r.setSeconds(parseFloat(i));
  },
  U: function(r, i) {
    return new Date(parseFloat(i) * 1e3);
  },
  W: function(r, i, e) {
    var f = parseInt(i), v = new Date(r.getFullYear(), 0, 2 + (f - 1) * 7, 0, 0, 0, 0);
    return v.setDate(v.getDate() - v.getDay() + e.firstDayOfWeek), v;
  },
  Y: function(r, i) {
    r.setFullYear(parseFloat(i));
  },
  Z: function(r, i) {
    return new Date(i);
  },
  d: function(r, i) {
    r.setDate(parseFloat(i));
  },
  h: function(r, i) {
    r.setHours((r.getHours() >= 12 ? 12 : 0) + parseFloat(i));
  },
  i: function(r, i) {
    r.setMinutes(parseFloat(i));
  },
  j: function(r, i) {
    r.setDate(parseFloat(i));
  },
  l: jn,
  m: function(r, i) {
    r.setMonth(parseFloat(i) - 1);
  },
  n: function(r, i) {
    r.setMonth(parseFloat(i) - 1);
  },
  s: function(r, i) {
    r.setSeconds(parseFloat(i));
  },
  u: function(r, i) {
    return new Date(parseFloat(i));
  },
  w: jn,
  y: function(r, i) {
    r.setFullYear(2e3 + parseFloat(i));
  }
}, Ve = {
  D: "",
  F: "",
  G: "(\\d\\d|\\d)",
  H: "(\\d\\d|\\d)",
  J: "(\\d\\d|\\d)\\w+",
  K: "",
  M: "",
  S: "(\\d\\d|\\d)",
  U: "(.+)",
  W: "(\\d\\d|\\d)",
  Y: "(\\d{4})",
  Z: "(.+)",
  d: "(\\d\\d|\\d)",
  h: "(\\d\\d|\\d)",
  i: "(\\d\\d|\\d)",
  j: "(\\d\\d|\\d)",
  l: "",
  m: "(\\d\\d|\\d)",
  n: "(\\d\\d|\\d)",
  s: "(\\d\\d|\\d)",
  u: "(.+)",
  w: "(\\d\\d|\\d)",
  y: "(\\d{2})"
}, cn = {
  Z: function(r) {
    return r.toISOString();
  },
  D: function(r, i, e) {
    return i.weekdays.shorthand[cn.w(r, i, e)];
  },
  F: function(r, i, e) {
    return bn(cn.n(r, i, e) - 1, !1, i);
  },
  G: function(r, i, e) {
    return Ce(cn.h(r, i, e));
  },
  H: function(r) {
    return Ce(r.getHours());
  },
  J: function(r, i) {
    return i.ordinal !== void 0 ? r.getDate() + i.ordinal(r.getDate()) : r.getDate();
  },
  K: function(r, i) {
    return i.amPM[Oe(r.getHours() > 11)];
  },
  M: function(r, i) {
    return bn(r.getMonth(), !0, i);
  },
  S: function(r) {
    return Ce(r.getSeconds());
  },
  U: function(r) {
    return r.getTime() / 1e3;
  },
  W: function(r, i, e) {
    return e.getWeek(r);
  },
  Y: function(r) {
    return Ce(r.getFullYear(), 4);
  },
  d: function(r) {
    return Ce(r.getDate());
  },
  h: function(r) {
    return r.getHours() % 12 ? r.getHours() % 12 : 12;
  },
  i: function(r) {
    return Ce(r.getMinutes());
  },
  j: function(r) {
    return r.getDate();
  },
  l: function(r, i) {
    return i.weekdays.longhand[r.getDay()];
  },
  m: function(r) {
    return Ce(r.getMonth() + 1);
  },
  n: function(r) {
    return r.getMonth() + 1;
  },
  s: function(r) {
    return r.getSeconds();
  },
  u: function(r) {
    return r.getTime();
  },
  w: function(r) {
    return r.getDay();
  },
  y: function(r) {
    return String(r.getFullYear()).substring(2);
  }
}, ct = function(r) {
  var i = r.config, e = i === void 0 ? Ge : i, f = r.l10n, v = f === void 0 ? ln : f, l = r.isMobile, E = l === void 0 ? !1 : l;
  return function(m, D, N) {
    var C = N || v;
    return e.formatDate !== void 0 && !E ? e.formatDate(m, D, C) : D.split("").map(function(x, L, q) {
      return cn[x] && q[L - 1] !== "\\" ? cn[x](m, C, e) : x !== "\\" ? x : "";
    }).join("");
  };
}, Wn = function(r) {
  var i = r.config, e = i === void 0 ? Ge : i, f = r.l10n, v = f === void 0 ? ln : f;
  return function(l, E, m, D) {
    if (!(l !== 0 && !l)) {
      var N = D || v, C, x = l;
      if (l instanceof Date)
        C = new Date(l.getTime());
      else if (typeof l != "string" && l.toFixed !== void 0)
        C = new Date(l);
      else if (typeof l == "string") {
        var L = E || (e || Ge).dateFormat, q = String(l).trim();
        if (q === "today")
          C = /* @__PURE__ */ new Date(), m = !0;
        else if (e && e.parseDate)
          C = e.parseDate(l, L);
        else if (/Z$/.test(q) || /GMT$/.test(q))
          C = new Date(l);
        else {
          for (var ie = void 0, T = [], ee = 0, te = 0, B = ""; ee < L.length; ee++) {
            var Z = L[ee], Q = Z === "\\", y = L[ee - 1] === "\\" || Q;
            if (Ve[Z] && !y) {
              B += Ve[Z];
              var fe = new RegExp(B).exec(l);
              fe && (ie = !0) && T[Z !== "Y" ? "push" : "unshift"]({
                fn: Ot[Z],
                val: fe[++te]
              });
            } else
              Q || (B += ".");
          }
          C = !e || !e.noCalendar ? new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1, 0, 0, 0, 0) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0)), T.forEach(function(Me) {
            var Te = Me.fn, Re = Me.val;
            return C = Te(C, Re, N) || C;
          }), C = ie ? C : void 0;
        }
      }
      if (!(C instanceof Date && !isNaN(C.getTime()))) {
        e.errorHandler(new Error("Invalid date provided: " + x));
        return;
      }
      return m === !0 && C.setHours(0, 0, 0, 0), C;
    }
  };
};
function Ee(r, i, e) {
  return e === void 0 && (e = !0), e !== !1 ? new Date(r.getTime()).setHours(0, 0, 0, 0) - new Date(i.getTime()).setHours(0, 0, 0, 0) : r.getTime() - i.getTime();
}
var Pt = function(r, i, e) {
  return r > Math.min(i, e) && r < Math.max(i, e);
}, Fn = function(r, i, e) {
  return r * 3600 + i * 60 + e;
}, kt = function(r) {
  var i = Math.floor(r / 3600), e = (r - i * 3600) / 60;
  return [i, e, r - i * 3600 - e * 60];
}, Rt = {
  DAY: 864e5
};
function Yn(r) {
  var i = r.defaultHour, e = r.defaultMinute, f = r.defaultSeconds;
  if (r.minDate !== void 0) {
    var v = r.minDate.getHours(), l = r.minDate.getMinutes(), E = r.minDate.getSeconds();
    i < v && (i = v), i === v && e < l && (e = l), i === v && e === l && f < E && (f = r.minDate.getSeconds());
  }
  if (r.maxDate !== void 0) {
    var m = r.maxDate.getHours(), D = r.maxDate.getMinutes();
    i = Math.min(i, m), i === m && (e = Math.min(D, e)), i === m && e === D && (f = r.maxDate.getSeconds());
  }
  return { hours: i, minutes: e, seconds: f };
}
typeof Object.assign != "function" && (Object.assign = function(r) {
  for (var i = [], e = 1; e < arguments.length; e++)
    i[e - 1] = arguments[e];
  if (!r)
    throw TypeError("Cannot convert undefined or null to object");
  for (var f = function(m) {
    m && Object.keys(m).forEach(function(D) {
      return r[D] = m[D];
    });
  }, v = 0, l = i; v < l.length; v++) {
    var E = l[v];
    f(E);
  }
  return r;
});
var pe = globalThis && globalThis.__assign || function() {
  return pe = Object.assign || function(r) {
    for (var i, e = 1, f = arguments.length; e < f; e++) {
      i = arguments[e];
      for (var v in i)
        Object.prototype.hasOwnProperty.call(i, v) && (r[v] = i[v]);
    }
    return r;
  }, pe.apply(this, arguments);
}, rt = globalThis && globalThis.__spreadArrays || function() {
  for (var r = 0, i = 0, e = arguments.length; i < e; i++)
    r += arguments[i].length;
  for (var f = Array(r), v = 0, i = 0; i < e; i++)
    for (var l = arguments[i], E = 0, m = l.length; E < m; E++, v++)
      f[v] = l[E];
  return f;
}, It = 300;
function At(r, i) {
  var e = {
    config: pe(pe({}, Ge), ue.defaultConfig),
    l10n: ln
  };
  e.parseDate = Wn({ config: e.config, l10n: e.l10n }), e._handlers = [], e.pluginElements = [], e.loadedPlugins = [], e._bind = T, e._setHoursFromDate = L, e._positionCalendar = Fe, e.changeMonth = b, e.changeYear = P, e.clear = F, e.close = A, e.onMouseOver = p, e._createElement = K, e.createDay = fe, e.destroy = R, e.isEnabled = k, e.jumpToDate = B, e.updateValue = de, e.open = Ne, e.redraw = Be, e.set = pn, e.setDate = wn, e.toggle = Mn;
  function f() {
    e.utils = {
      getDaysInMonth: function(n, t) {
        return n === void 0 && (n = e.currentMonth), t === void 0 && (t = e.currentYear), n === 1 && (t % 4 === 0 && t % 100 !== 0 || t % 400 === 0) ? 29 : e.l10n.daysInMonth[n];
      }
    };
  }
  function v() {
    e.element = e.input = r, e.isOpen = !1, $e(), Qe(), tn(), gn(), f(), e.isMobile || y(), te(), (e.selectedDates.length || e.config.noCalendar) && (e.config.enableTime && L(e.config.noCalendar ? e.latestSelectedDateObj : void 0), de(!1)), m();
    var n = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    !e.isMobile && n && Fe(), ne("onReady");
  }
  function l() {
    var n;
    return ((n = e.calendarContainer) === null || n === void 0 ? void 0 : n.getRootNode()).activeElement || document.activeElement;
  }
  function E(n) {
    return n.bind(e);
  }
  function m() {
    var n = e.config;
    n.weekNumbers === !1 && n.showMonths === 1 || n.noCalendar !== !0 && window.requestAnimationFrame(function() {
      if (e.calendarContainer !== void 0 && (e.calendarContainer.style.visibility = "hidden", e.calendarContainer.style.display = "block"), e.daysContainer !== void 0) {
        var t = (e.days.offsetWidth + 1) * n.showMonths;
        e.daysContainer.style.width = t + "px", e.calendarContainer.style.width = t + (e.weekWrapper !== void 0 ? e.weekWrapper.offsetWidth : 0) + "px", e.calendarContainer.style.removeProperty("visibility"), e.calendarContainer.style.removeProperty("display");
      }
    });
  }
  function D(n) {
    if (e.selectedDates.length === 0) {
      var t = e.config.minDate === void 0 || Ee(/* @__PURE__ */ new Date(), e.config.minDate) >= 0 ? /* @__PURE__ */ new Date() : new Date(e.config.minDate.getTime()), o = Yn(e.config);
      t.setHours(o.hours, o.minutes, o.seconds, t.getMilliseconds()), e.selectedDates = [t], e.latestSelectedDateObj = t;
    }
    n !== void 0 && n.type !== "blur" && un(n);
    var u = e._input.value;
    x(), de(), e._input.value !== u && e._debouncedChange();
  }
  function N(n, t) {
    return n % 12 + 12 * Oe(t === e.l10n.amPM[1]);
  }
  function C(n) {
    switch (n % 24) {
      case 0:
      case 12:
        return 12;
      default:
        return n % 12;
    }
  }
  function x() {
    if (!(e.hourElement === void 0 || e.minuteElement === void 0)) {
      var n = (parseInt(e.hourElement.value.slice(-2), 10) || 0) % 24, t = (parseInt(e.minuteElement.value, 10) || 0) % 60, o = e.secondElement !== void 0 ? (parseInt(e.secondElement.value, 10) || 0) % 60 : 0;
      e.amPM !== void 0 && (n = N(n, e.amPM.textContent));
      var u = e.config.minTime !== void 0 || e.config.minDate && e.minDateHasTime && e.latestSelectedDateObj && Ee(e.latestSelectedDateObj, e.config.minDate, !0) === 0, d = e.config.maxTime !== void 0 || e.config.maxDate && e.maxDateHasTime && e.latestSelectedDateObj && Ee(e.latestSelectedDateObj, e.config.maxDate, !0) === 0;
      if (e.config.maxTime !== void 0 && e.config.minTime !== void 0 && e.config.minTime > e.config.maxTime) {
        var h = Fn(e.config.minTime.getHours(), e.config.minTime.getMinutes(), e.config.minTime.getSeconds()), I = Fn(e.config.maxTime.getHours(), e.config.maxTime.getMinutes(), e.config.maxTime.getSeconds()), M = Fn(n, t, o);
        if (M > I && M < h) {
          var j = kt(h);
          n = j[0], t = j[1], o = j[2];
        }
      } else {
        if (d) {
          var w = e.config.maxTime !== void 0 ? e.config.maxTime : e.config.maxDate;
          n = Math.min(n, w.getHours()), n === w.getHours() && (t = Math.min(t, w.getMinutes())), t === w.getMinutes() && (o = Math.min(o, w.getSeconds()));
        }
        if (u) {
          var S = e.config.minTime !== void 0 ? e.config.minTime : e.config.minDate;
          n = Math.max(n, S.getHours()), n === S.getHours() && t < S.getMinutes() && (t = S.getMinutes()), t === S.getMinutes() && (o = Math.max(o, S.getSeconds()));
        }
      }
      q(n, t, o);
    }
  }
  function L(n) {
    var t = n || e.latestSelectedDateObj;
    t && t instanceof Date && q(t.getHours(), t.getMinutes(), t.getSeconds());
  }
  function q(n, t, o) {
    e.latestSelectedDateObj !== void 0 && e.latestSelectedDateObj.setHours(n % 24, t, o || 0, 0), !(!e.hourElement || !e.minuteElement || e.isMobile) && (e.hourElement.value = Ce(e.config.time_24hr ? n : (12 + n) % 12 + 12 * Oe(n % 12 === 0)), e.minuteElement.value = Ce(t), e.amPM !== void 0 && (e.amPM.textContent = e.l10n.amPM[Oe(n >= 12)]), e.secondElement !== void 0 && (e.secondElement.value = Ce(o)));
  }
  function ie(n) {
    var t = we(n), o = parseInt(t.value) + (n.delta || 0);
    (o / 1e3 > 1 || n.key === "Enter" && !/[^\d]/.test(o.toString())) && P(o);
  }
  function T(n, t, o, u) {
    if (t instanceof Array)
      return t.forEach(function(d) {
        return T(n, d, o, u);
      });
    if (n instanceof Array)
      return n.forEach(function(d) {
        return T(d, t, o, u);
      });
    n.addEventListener(t, o, u), e._handlers.push({
      remove: function() {
        return n.removeEventListener(t, o, u);
      }
    });
  }
  function ee() {
    ne("onChange");
  }
  function te() {
    if (e.config.wrap && ["open", "close", "toggle", "clear"].forEach(function(o) {
      Array.prototype.forEach.call(e.element.querySelectorAll("[data-" + o + "]"), function(u) {
        return T(u, "click", e[o]);
      });
    }), e.isMobile) {
      En();
      return;
    }
    var n = tt(ye, 50);
    if (e._debouncedChange = tt(ee, It), e.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && T(e.daysContainer, "mouseover", function(o) {
      e.config.mode === "range" && p(we(o));
    }), T(e._input, "keydown", se), e.calendarContainer !== void 0 && T(e.calendarContainer, "keydown", se), !e.config.inline && !e.config.static && T(window, "resize", n), window.ontouchstart !== void 0 ? T(window.document, "touchstart", O) : T(window.document, "mousedown", O), T(window.document, "focus", O, { capture: !0 }), e.config.clickOpens === !0 && (T(e._input, "focus", e.open), T(e._input, "click", e.open)), e.daysContainer !== void 0 && (T(e.monthNav, "click", on), T(e.monthNav, ["keyup", "increment"], ie), T(e.daysContainer, "click", dn)), e.timeContainer !== void 0 && e.minuteElement !== void 0 && e.hourElement !== void 0) {
      var t = function(o) {
        return we(o).select();
      };
      T(e.timeContainer, ["increment"], D), T(e.timeContainer, "blur", D, { capture: !0 }), T(e.timeContainer, "click", Z), T([e.hourElement, e.minuteElement], ["focus", "click"], t), e.secondElement !== void 0 && T(e.secondElement, "focus", function() {
        return e.secondElement && e.secondElement.select();
      }), e.amPM !== void 0 && T(e.amPM, "click", function(o) {
        D(o);
      });
    }
    e.config.allowInput && T(e._input, "blur", H);
  }
  function B(n, t) {
    var o = n !== void 0 ? e.parseDate(n) : e.latestSelectedDateObj || (e.config.minDate && e.config.minDate > e.now ? e.config.minDate : e.config.maxDate && e.config.maxDate < e.now ? e.config.maxDate : e.now), u = e.currentYear, d = e.currentMonth;
    try {
      o !== void 0 && (e.currentYear = o.getFullYear(), e.currentMonth = o.getMonth());
    } catch (h) {
      h.message = "Invalid date supplied: " + o, e.config.errorHandler(h);
    }
    t && e.currentYear !== u && (ne("onYearChange"), oe()), t && (e.currentYear !== u || e.currentMonth !== d) && ne("onMonthChange"), e.redraw();
  }
  function Z(n) {
    var t = we(n);
    ~t.className.indexOf("arrow") && Q(n, t.classList.contains("arrowUp") ? 1 : -1);
  }
  function Q(n, t, o) {
    var u = n && we(n), d = o || u && u.parentNode && u.parentNode.firstChild, h = rn("increment");
    h.delta = t, d && d.dispatchEvent(h);
  }
  function y() {
    var n = window.document.createDocumentFragment();
    if (e.calendarContainer = K("div", "flatpickr-calendar"), e.calendarContainer.tabIndex = -1, !e.config.noCalendar) {
      if (n.appendChild(ge()), e.innerContainer = K("div", "flatpickr-innerContainer"), e.config.weekNumbers) {
        var t = c(), o = t.weekWrapper, u = t.weekNumbers;
        e.innerContainer.appendChild(o), e.weekNumbers = u, e.weekWrapper = o;
      }
      e.rContainer = K("div", "flatpickr-rContainer"), e.rContainer.appendChild(Ie()), e.daysContainer || (e.daysContainer = K("div", "flatpickr-days"), e.daysContainer.tabIndex = -1), ke(), e.rContainer.appendChild(e.daysContainer), e.innerContainer.appendChild(e.rContainer), n.appendChild(e.innerContainer);
    }
    e.config.enableTime && n.appendChild(xe()), ve(e.calendarContainer, "rangeMode", e.config.mode === "range"), ve(e.calendarContainer, "animate", e.config.animate === !0), ve(e.calendarContainer, "multiMonth", e.config.showMonths > 1), e.calendarContainer.appendChild(n);
    var d = e.config.appendTo !== void 0 && e.config.appendTo.nodeType !== void 0;
    if ((e.config.inline || e.config.static) && (e.calendarContainer.classList.add(e.config.inline ? "inline" : "static"), e.config.inline && (!d && e.element.parentNode ? e.element.parentNode.insertBefore(e.calendarContainer, e._input.nextSibling) : e.config.appendTo !== void 0 && e.config.appendTo.appendChild(e.calendarContainer)), e.config.static)) {
      var h = K("div", "flatpickr-wrapper");
      e.element.parentNode && e.element.parentNode.insertBefore(h, e.element), h.appendChild(e.element), e.altInput && h.appendChild(e.altInput), h.appendChild(e.calendarContainer);
    }
    !e.config.static && !e.config.inline && (e.config.appendTo !== void 0 ? e.config.appendTo : window.document.body).appendChild(e.calendarContainer);
  }
  function fe(n, t, o, u) {
    var d = k(t, !0), h = K("span", n, t.getDate().toString());
    return h.dateObj = t, h.$i = u, h.setAttribute("aria-label", e.formatDate(t, e.config.ariaDateFormat)), n.indexOf("hidden") === -1 && Ee(t, e.now) === 0 && (e.todayDateElem = h, h.classList.add("today"), h.setAttribute("aria-current", "date")), d ? (h.tabIndex = -1, an(t) && (h.classList.add("selected"), e.selectedDateElem = h, e.config.mode === "range" && (ve(h, "startRange", e.selectedDates[0] && Ee(t, e.selectedDates[0], !0) === 0), ve(h, "endRange", e.selectedDates[1] && Ee(t, e.selectedDates[1], !0) === 0), n === "nextMonthDay" && h.classList.add("inRange")))) : h.classList.add("flatpickr-disabled"), e.config.mode === "range" && Tn(t) && !an(t) && h.classList.add("inRange"), e.weekNumbers && e.config.showMonths === 1 && n !== "prevMonthDay" && u % 7 === 6 && e.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + e.config.getWeek(t) + "</span>"), ne("onDayCreate", h), h;
  }
  function Me(n) {
    n.focus(), e.config.mode === "range" && p(n);
  }
  function Te(n) {
    for (var t = n > 0 ? 0 : e.config.showMonths - 1, o = n > 0 ? e.config.showMonths : -1, u = t; u != o; u += n)
      for (var d = e.daysContainer.children[u], h = n > 0 ? 0 : d.children.length - 1, I = n > 0 ? d.children.length : -1, M = h; M != I; M += n) {
        var j = d.children[M];
        if (j.className.indexOf("hidden") === -1 && k(j.dateObj))
          return j;
      }
  }
  function Re(n, t) {
    for (var o = n.className.indexOf("Month") === -1 ? n.dateObj.getMonth() : e.currentMonth, u = t > 0 ? e.config.showMonths : -1, d = t > 0 ? 1 : -1, h = o - e.currentMonth; h != u; h += d)
      for (var I = e.daysContainer.children[h], M = o - e.currentMonth === h ? n.$i + t : t < 0 ? I.children.length - 1 : 0, j = I.children.length, w = M; w >= 0 && w < j && w != (t > 0 ? j : -1); w += d) {
        var S = I.children[w];
        if (S.className.indexOf("hidden") === -1 && k(S.dateObj) && Math.abs(n.$i - w) >= Math.abs(t))
          return Me(S);
      }
    e.changeMonth(d), Pe(Te(d), 0);
  }
  function Pe(n, t) {
    var o = l(), u = W(o || document.body), d = n !== void 0 ? n : u ? o : e.selectedDateElem !== void 0 && W(e.selectedDateElem) ? e.selectedDateElem : e.todayDateElem !== void 0 && W(e.todayDateElem) ? e.todayDateElem : Te(t > 0 ? 1 : -1);
    d === void 0 ? e._input.focus() : u ? Re(d, t) : Me(d);
  }
  function Ye(n, t) {
    for (var o = (new Date(n, t, 1).getDay() - e.l10n.firstDayOfWeek + 7) % 7, u = e.utils.getDaysInMonth((t - 1 + 12) % 12, n), d = e.utils.getDaysInMonth(t, n), h = window.document.createDocumentFragment(), I = e.config.showMonths > 1, M = I ? "prevMonthDay hidden" : "prevMonthDay", j = I ? "nextMonthDay hidden" : "nextMonthDay", w = u + 1 - o, S = 0; w <= u; w++, S++)
      h.appendChild(fe("flatpickr-day " + M, new Date(n, t - 1, w), w, S));
    for (w = 1; w <= d; w++, S++)
      h.appendChild(fe("flatpickr-day", new Date(n, t, w), w, S));
    for (var G = d + 1; G <= 42 - o && (e.config.showMonths === 1 || S % 7 !== 0); G++, S++)
      h.appendChild(fe("flatpickr-day " + j, new Date(n, t + 1, G % d), G, S));
    var Se = K("div", "dayContainer");
    return Se.appendChild(h), Se;
  }
  function ke() {
    if (e.daysContainer !== void 0) {
      hn(e.daysContainer), e.weekNumbers && hn(e.weekNumbers);
      for (var n = document.createDocumentFragment(), t = 0; t < e.config.showMonths; t++) {
        var o = new Date(e.currentYear, e.currentMonth, 1);
        o.setMonth(e.currentMonth + t), n.appendChild(Ye(o.getFullYear(), o.getMonth()));
      }
      e.daysContainer.appendChild(n), e.days = e.daysContainer.firstChild, e.config.mode === "range" && e.selectedDates.length === 1 && p();
    }
  }
  function oe() {
    if (!(e.config.showMonths > 1 || e.config.monthSelectorType !== "dropdown")) {
      var n = function(u) {
        return e.config.minDate !== void 0 && e.currentYear === e.config.minDate.getFullYear() && u < e.config.minDate.getMonth() ? !1 : !(e.config.maxDate !== void 0 && e.currentYear === e.config.maxDate.getFullYear() && u > e.config.maxDate.getMonth());
      };
      e.monthsDropdownContainer.tabIndex = -1, e.monthsDropdownContainer.innerHTML = "";
      for (var t = 0; t < 12; t++)
        if (n(t)) {
          var o = K("option", "flatpickr-monthDropdown-month");
          o.value = new Date(e.currentYear, t).getMonth().toString(), o.textContent = bn(t, e.config.shorthandCurrentMonth, e.l10n), o.tabIndex = -1, e.currentMonth === t && (o.selected = !0), e.monthsDropdownContainer.appendChild(o);
        }
    }
  }
  function le() {
    var n = K("div", "flatpickr-month"), t = window.document.createDocumentFragment(), o;
    e.config.showMonths > 1 || e.config.monthSelectorType === "static" ? o = K("span", "cur-month") : (e.monthsDropdownContainer = K("select", "flatpickr-monthDropdown-months"), e.monthsDropdownContainer.setAttribute("aria-label", e.l10n.monthAriaLabel), T(e.monthsDropdownContainer, "change", function(I) {
      var M = we(I), j = parseInt(M.value, 10);
      e.changeMonth(j - e.currentMonth), ne("onMonthChange");
    }), oe(), o = e.monthsDropdownContainer);
    var u = yn("cur-year", { tabindex: "-1" }), d = u.getElementsByTagName("input")[0];
    d.setAttribute("aria-label", e.l10n.yearAriaLabel), e.config.minDate && d.setAttribute("min", e.config.minDate.getFullYear().toString()), e.config.maxDate && (d.setAttribute("max", e.config.maxDate.getFullYear().toString()), d.disabled = !!e.config.minDate && e.config.minDate.getFullYear() === e.config.maxDate.getFullYear());
    var h = K("div", "flatpickr-current-month");
    return h.appendChild(o), h.appendChild(u), t.appendChild(h), n.appendChild(t), {
      container: n,
      yearElement: d,
      monthElement: o
    };
  }
  function _e() {
    hn(e.monthNav), e.monthNav.appendChild(e.prevMonthNav), e.config.showMonths && (e.yearElements = [], e.monthElements = []);
    for (var n = e.config.showMonths; n--; ) {
      var t = le();
      e.yearElements.push(t.yearElement), e.monthElements.push(t.monthElement), e.monthNav.appendChild(t.container);
    }
    e.monthNav.appendChild(e.nextMonthNav);
  }
  function ge() {
    return e.monthNav = K("div", "flatpickr-months"), e.yearElements = [], e.monthElements = [], e.prevMonthNav = K("span", "flatpickr-prev-month"), e.prevMonthNav.innerHTML = e.config.prevArrow, e.nextMonthNav = K("span", "flatpickr-next-month"), e.nextMonthNav.innerHTML = e.config.nextArrow, _e(), Object.defineProperty(e, "_hidePrevMonthArrow", {
      get: function() {
        return e.__hidePrevMonthArrow;
      },
      set: function(n) {
        e.__hidePrevMonthArrow !== n && (ve(e.prevMonthNav, "flatpickr-disabled", n), e.__hidePrevMonthArrow = n);
      }
    }), Object.defineProperty(e, "_hideNextMonthArrow", {
      get: function() {
        return e.__hideNextMonthArrow;
      },
      set: function(n) {
        e.__hideNextMonthArrow !== n && (ve(e.nextMonthNav, "flatpickr-disabled", n), e.__hideNextMonthArrow = n);
      }
    }), e.currentYearElement = e.yearElements[0], He(), e.monthNav;
  }
  function xe() {
    e.calendarContainer.classList.add("hasTime"), e.config.noCalendar && e.calendarContainer.classList.add("noCalendar");
    var n = Yn(e.config);
    e.timeContainer = K("div", "flatpickr-time"), e.timeContainer.tabIndex = -1;
    var t = K("span", "flatpickr-time-separator", ":"), o = yn("flatpickr-hour", {
      "aria-label": e.l10n.hourAriaLabel
    });
    e.hourElement = o.getElementsByTagName("input")[0];
    var u = yn("flatpickr-minute", {
      "aria-label": e.l10n.minuteAriaLabel
    });
    if (e.minuteElement = u.getElementsByTagName("input")[0], e.hourElement.tabIndex = e.minuteElement.tabIndex = -1, e.hourElement.value = Ce(e.latestSelectedDateObj ? e.latestSelectedDateObj.getHours() : e.config.time_24hr ? n.hours : C(n.hours)), e.minuteElement.value = Ce(e.latestSelectedDateObj ? e.latestSelectedDateObj.getMinutes() : n.minutes), e.hourElement.setAttribute("step", e.config.hourIncrement.toString()), e.minuteElement.setAttribute("step", e.config.minuteIncrement.toString()), e.hourElement.setAttribute("min", e.config.time_24hr ? "0" : "1"), e.hourElement.setAttribute("max", e.config.time_24hr ? "23" : "12"), e.hourElement.setAttribute("maxlength", "2"), e.minuteElement.setAttribute("min", "0"), e.minuteElement.setAttribute("max", "59"), e.minuteElement.setAttribute("maxlength", "2"), e.timeContainer.appendChild(o), e.timeContainer.appendChild(t), e.timeContainer.appendChild(u), e.config.time_24hr && e.timeContainer.classList.add("time24hr"), e.config.enableSeconds) {
      e.timeContainer.classList.add("hasSeconds");
      var d = yn("flatpickr-second");
      e.secondElement = d.getElementsByTagName("input")[0], e.secondElement.value = Ce(e.latestSelectedDateObj ? e.latestSelectedDateObj.getSeconds() : n.seconds), e.secondElement.setAttribute("step", e.minuteElement.getAttribute("step")), e.secondElement.setAttribute("min", "0"), e.secondElement.setAttribute("max", "59"), e.secondElement.setAttribute("maxlength", "2"), e.timeContainer.appendChild(K("span", "flatpickr-time-separator", ":")), e.timeContainer.appendChild(d);
    }
    return e.config.time_24hr || (e.amPM = K("span", "flatpickr-am-pm", e.l10n.amPM[Oe((e.latestSelectedDateObj ? e.hourElement.value : e.config.defaultHour) > 11)]), e.amPM.title = e.l10n.toggleTitle, e.amPM.tabIndex = -1, e.timeContainer.appendChild(e.amPM)), e.timeContainer;
  }
  function Ie() {
    e.weekdayContainer ? hn(e.weekdayContainer) : e.weekdayContainer = K("div", "flatpickr-weekdays");
    for (var n = e.config.showMonths; n--; ) {
      var t = K("div", "flatpickr-weekdaycontainer");
      e.weekdayContainer.appendChild(t);
    }
    return je(), e.weekdayContainer;
  }
  function je() {
    if (e.weekdayContainer) {
      var n = e.l10n.firstDayOfWeek, t = rt(e.l10n.weekdays.shorthand);
      n > 0 && n < t.length && (t = rt(t.splice(n, t.length), t.splice(0, n)));
      for (var o = e.config.showMonths; o--; )
        e.weekdayContainer.children[o].innerHTML = `
      <span class='flatpickr-weekday'>
        ` + t.join("</span><span class='flatpickr-weekday'>") + `
      </span>
      `;
    }
  }
  function c() {
    e.calendarContainer.classList.add("hasWeeks");
    var n = K("div", "flatpickr-weekwrapper");
    n.appendChild(K("span", "flatpickr-weekday", e.l10n.weekAbbreviation));
    var t = K("div", "flatpickr-weeks");
    return n.appendChild(t), {
      weekWrapper: n,
      weekNumbers: t
    };
  }
  function b(n, t) {
    t === void 0 && (t = !0);
    var o = t ? n : n - e.currentMonth;
    o < 0 && e._hidePrevMonthArrow === !0 || o > 0 && e._hideNextMonthArrow === !0 || (e.currentMonth += o, (e.currentMonth < 0 || e.currentMonth > 11) && (e.currentYear += e.currentMonth > 11 ? 1 : -1, e.currentMonth = (e.currentMonth + 12) % 12, ne("onYearChange"), oe()), ke(), ne("onMonthChange"), He());
  }
  function F(n, t) {
    if (n === void 0 && (n = !0), t === void 0 && (t = !0), e.input.value = "", e.altInput !== void 0 && (e.altInput.value = ""), e.mobileInput !== void 0 && (e.mobileInput.value = ""), e.selectedDates = [], e.latestSelectedDateObj = void 0, t === !0 && (e.currentYear = e._initialDate.getFullYear(), e.currentMonth = e._initialDate.getMonth()), e.config.enableTime === !0) {
      var o = Yn(e.config), u = o.hours, d = o.minutes, h = o.seconds;
      q(u, d, h);
    }
    e.redraw(), n && ne("onChange");
  }
  function A() {
    e.isOpen = !1, e.isMobile || (e.calendarContainer !== void 0 && e.calendarContainer.classList.remove("open"), e._input !== void 0 && e._input.classList.remove("active")), ne("onClose");
  }
  function R() {
    e.config !== void 0 && ne("onDestroy");
    for (var n = e._handlers.length; n--; )
      e._handlers[n].remove();
    if (e._handlers = [], e.mobileInput)
      e.mobileInput.parentNode && e.mobileInput.parentNode.removeChild(e.mobileInput), e.mobileInput = void 0;
    else if (e.calendarContainer && e.calendarContainer.parentNode)
      if (e.config.static && e.calendarContainer.parentNode) {
        var t = e.calendarContainer.parentNode;
        if (t.lastChild && t.removeChild(t.lastChild), t.parentNode) {
          for (; t.firstChild; )
            t.parentNode.insertBefore(t.firstChild, t);
          t.parentNode.removeChild(t);
        }
      } else
        e.calendarContainer.parentNode.removeChild(e.calendarContainer);
    e.altInput && (e.input.type = "text", e.altInput.parentNode && e.altInput.parentNode.removeChild(e.altInput), delete e.altInput), e.input && (e.input.type = e.input._type, e.input.classList.remove("flatpickr-input"), e.input.removeAttribute("readonly")), [
      "_showTimeInput",
      "latestSelectedDateObj",
      "_hideNextMonthArrow",
      "_hidePrevMonthArrow",
      "__hideNextMonthArrow",
      "__hidePrevMonthArrow",
      "isMobile",
      "isOpen",
      "selectedDateElem",
      "minDateHasTime",
      "maxDateHasTime",
      "days",
      "daysContainer",
      "_input",
      "_positionElement",
      "innerContainer",
      "rContainer",
      "monthNav",
      "todayDateElem",
      "calendarContainer",
      "weekdayContainer",
      "prevMonthNav",
      "nextMonthNav",
      "monthsDropdownContainer",
      "currentMonthElement",
      "currentYearElement",
      "navigationCurrentMonth",
      "selectedDateElem",
      "config"
    ].forEach(function(o) {
      try {
        delete e[o];
      } catch {
      }
    });
  }
  function Y(n) {
    return e.calendarContainer.contains(n);
  }
  function O(n) {
    if (e.isOpen && !e.config.inline) {
      var t = we(n), o = Y(t), u = t === e.input || t === e.altInput || e.element.contains(t) || n.path && n.path.indexOf && (~n.path.indexOf(e.input) || ~n.path.indexOf(e.altInput)), d = !u && !o && !Y(n.relatedTarget), h = !e.config.ignoredFocusElements.some(function(I) {
        return I.contains(t);
      });
      d && h && (e.config.allowInput && e.setDate(e._input.value, !1, e.config.altInput ? e.config.altFormat : e.config.dateFormat), e.timeContainer !== void 0 && e.minuteElement !== void 0 && e.hourElement !== void 0 && e.input.value !== "" && e.input.value !== void 0 && D(), e.close(), e.config && e.config.mode === "range" && e.selectedDates.length === 1 && e.clear(!1));
    }
  }
  function P(n) {
    if (!(!n || e.config.minDate && n < e.config.minDate.getFullYear() || e.config.maxDate && n > e.config.maxDate.getFullYear())) {
      var t = n, o = e.currentYear !== t;
      e.currentYear = t || e.currentYear, e.config.maxDate && e.currentYear === e.config.maxDate.getFullYear() ? e.currentMonth = Math.min(e.config.maxDate.getMonth(), e.currentMonth) : e.config.minDate && e.currentYear === e.config.minDate.getFullYear() && (e.currentMonth = Math.max(e.config.minDate.getMonth(), e.currentMonth)), o && (e.redraw(), ne("onYearChange"), oe());
    }
  }
  function k(n, t) {
    var o;
    t === void 0 && (t = !0);
    var u = e.parseDate(n, void 0, t);
    if (e.config.minDate && u && Ee(u, e.config.minDate, t !== void 0 ? t : !e.minDateHasTime) < 0 || e.config.maxDate && u && Ee(u, e.config.maxDate, t !== void 0 ? t : !e.maxDateHasTime) > 0)
      return !1;
    if (!e.config.enable && e.config.disable.length === 0)
      return !0;
    if (u === void 0)
      return !1;
    for (var d = !!e.config.enable, h = (o = e.config.enable) !== null && o !== void 0 ? o : e.config.disable, I = 0, M = void 0; I < h.length; I++) {
      if (M = h[I], typeof M == "function" && M(u))
        return d;
      if (M instanceof Date && u !== void 0 && M.getTime() === u.getTime())
        return d;
      if (typeof M == "string") {
        var j = e.parseDate(M, void 0, !0);
        return j && j.getTime() === u.getTime() ? d : !d;
      } else if (typeof M == "object" && u !== void 0 && M.from && M.to && u.getTime() >= M.from.getTime() && u.getTime() <= M.to.getTime())
        return d;
    }
    return !d;
  }
  function W(n) {
    return e.daysContainer !== void 0 ? n.className.indexOf("hidden") === -1 && n.className.indexOf("flatpickr-disabled") === -1 && e.daysContainer.contains(n) : !1;
  }
  function H(n) {
    var t = n.target === e._input, o = e._input.value.trimEnd() !== Ke();
    t && o && !(n.relatedTarget && Y(n.relatedTarget)) && e.setDate(e._input.value, !0, n.target === e.altInput ? e.config.altFormat : e.config.dateFormat);
  }
  function se(n) {
    var t = we(n), o = e.config.wrap ? r.contains(t) : t === e._input, u = e.config.allowInput, d = e.isOpen && (!u || !o), h = e.config.inline && o && !u;
    if (n.keyCode === 13 && o) {
      if (u)
        return e.setDate(e._input.value, !0, t === e.altInput ? e.config.altFormat : e.config.dateFormat), e.close(), t.blur();
      e.open();
    } else if (Y(t) || d || h) {
      var I = !!e.timeContainer && e.timeContainer.contains(t);
      switch (n.keyCode) {
        case 13:
          I ? (n.preventDefault(), D(), en()) : dn(n);
          break;
        case 27:
          n.preventDefault(), en();
          break;
        case 8:
        case 46:
          o && !e.config.allowInput && (n.preventDefault(), e.clear());
          break;
        case 37:
        case 39:
          if (!I && !o) {
            n.preventDefault();
            var M = l();
            if (e.daysContainer !== void 0 && (u === !1 || M && W(M))) {
              var j = n.keyCode === 39 ? 1 : -1;
              n.ctrlKey ? (n.stopPropagation(), b(j), Pe(Te(1), 0)) : Pe(void 0, j);
            }
          } else
            e.hourElement && e.hourElement.focus();
          break;
        case 38:
        case 40:
          n.preventDefault();
          var w = n.keyCode === 40 ? 1 : -1;
          e.daysContainer && t.$i !== void 0 || t === e.input || t === e.altInput ? n.ctrlKey ? (n.stopPropagation(), P(e.currentYear - w), Pe(Te(1), 0)) : I || Pe(void 0, w * 7) : t === e.currentYearElement ? P(e.currentYear - w) : e.config.enableTime && (!I && e.hourElement && e.hourElement.focus(), D(n), e._debouncedChange());
          break;
        case 9:
          if (I) {
            var S = [
              e.hourElement,
              e.minuteElement,
              e.secondElement,
              e.amPM
            ].concat(e.pluginElements).filter(function(me) {
              return me;
            }), G = S.indexOf(t);
            if (G !== -1) {
              var Se = S[G + (n.shiftKey ? -1 : 1)];
              n.preventDefault(), (Se || e._input).focus();
            }
          } else
            !e.config.noCalendar && e.daysContainer && e.daysContainer.contains(t) && n.shiftKey && (n.preventDefault(), e._input.focus());
          break;
      }
    }
    if (e.amPM !== void 0 && t === e.amPM)
      switch (n.key) {
        case e.l10n.amPM[0].charAt(0):
        case e.l10n.amPM[0].charAt(0).toLowerCase():
          e.amPM.textContent = e.l10n.amPM[0], x(), de();
          break;
        case e.l10n.amPM[1].charAt(0):
        case e.l10n.amPM[1].charAt(0).toLowerCase():
          e.amPM.textContent = e.l10n.amPM[1], x(), de();
          break;
      }
    (o || Y(t)) && ne("onKeyDown", n);
  }
  function p(n, t) {
    if (t === void 0 && (t = "flatpickr-day"), !(e.selectedDates.length !== 1 || n && (!n.classList.contains(t) || n.classList.contains("flatpickr-disabled")))) {
      for (var o = n ? n.dateObj.getTime() : e.days.firstElementChild.dateObj.getTime(), u = e.parseDate(e.selectedDates[0], void 0, !0).getTime(), d = Math.min(o, e.selectedDates[0].getTime()), h = Math.max(o, e.selectedDates[0].getTime()), I = !1, M = 0, j = 0, w = d; w < h; w += Rt.DAY)
        k(new Date(w), !0) || (I = I || w > d && w < h, w < u && (!M || w > M) ? M = w : w > u && (!j || w < j) && (j = w));
      var S = Array.from(e.rContainer.querySelectorAll("*:nth-child(-n+" + e.config.showMonths + ") > ." + t));
      S.forEach(function(G) {
        var Se = G.dateObj, me = Se.getTime(), a = M > 0 && me < M || j > 0 && me > j;
        if (a) {
          G.classList.add("notAllowed"), ["inRange", "startRange", "endRange"].forEach(function(s) {
            G.classList.remove(s);
          });
          return;
        } else if (I && !a)
          return;
        ["startRange", "inRange", "endRange", "notAllowed"].forEach(function(s) {
          G.classList.remove(s);
        }), n !== void 0 && (n.classList.add(o <= e.selectedDates[0].getTime() ? "startRange" : "endRange"), u < o && me === u ? G.classList.add("startRange") : u > o && me === u && G.classList.add("endRange"), me >= M && (j === 0 || me <= j) && Pt(me, u, o) && G.classList.add("inRange"));
      });
    }
  }
  function ye() {
    e.isOpen && !e.config.static && !e.config.inline && Fe();
  }
  function Ne(n, t) {
    if (t === void 0 && (t = e._positionElement), e.isMobile === !0) {
      if (n) {
        n.preventDefault();
        var o = we(n);
        o && o.blur();
      }
      e.mobileInput !== void 0 && (e.mobileInput.focus(), e.mobileInput.click()), ne("onOpen");
      return;
    } else if (e._input.disabled || e.config.inline)
      return;
    var u = e.isOpen;
    e.isOpen = !0, u || (e.calendarContainer.classList.add("open"), e._input.classList.add("active"), ne("onOpen"), Fe(t)), e.config.enableTime === !0 && e.config.noCalendar === !0 && e.config.allowInput === !1 && (n === void 0 || !e.timeContainer.contains(n.relatedTarget)) && setTimeout(function() {
      return e.hourElement.select();
    }, 50);
  }
  function Ae(n) {
    return function(t) {
      var o = e.config["_" + n + "Date"] = e.parseDate(t, e.config.dateFormat), u = e.config["_" + (n === "min" ? "max" : "min") + "Date"];
      o !== void 0 && (e[n === "min" ? "minDateHasTime" : "maxDateHasTime"] = o.getHours() > 0 || o.getMinutes() > 0 || o.getSeconds() > 0), e.selectedDates && (e.selectedDates = e.selectedDates.filter(function(d) {
        return k(d);
      }), !e.selectedDates.length && n === "min" && L(o), de()), e.daysContainer && (Be(), o !== void 0 ? e.currentYearElement[n] = o.getFullYear().toString() : e.currentYearElement.removeAttribute(n), e.currentYearElement.disabled = !!u && o !== void 0 && u.getFullYear() === o.getFullYear());
    };
  }
  function $e() {
    var n = [
      "wrap",
      "weekNumbers",
      "allowInput",
      "allowInvalidPreload",
      "clickOpens",
      "time_24hr",
      "enableTime",
      "noCalendar",
      "altInput",
      "shorthandCurrentMonth",
      "inline",
      "static",
      "enableSeconds",
      "disableMobile"
    ], t = pe(pe({}, JSON.parse(JSON.stringify(r.dataset || {}))), i), o = {};
    e.config.parseDate = t.parseDate, e.config.formatDate = t.formatDate, Object.defineProperty(e.config, "enable", {
      get: function() {
        return e.config._enable;
      },
      set: function(S) {
        e.config._enable = nn(S);
      }
    }), Object.defineProperty(e.config, "disable", {
      get: function() {
        return e.config._disable;
      },
      set: function(S) {
        e.config._disable = nn(S);
      }
    });
    var u = t.mode === "time";
    if (!t.dateFormat && (t.enableTime || u)) {
      var d = ue.defaultConfig.dateFormat || Ge.dateFormat;
      o.dateFormat = t.noCalendar || u ? "H:i" + (t.enableSeconds ? ":S" : "") : d + " H:i" + (t.enableSeconds ? ":S" : "");
    }
    if (t.altInput && (t.enableTime || u) && !t.altFormat) {
      var h = ue.defaultConfig.altFormat || Ge.altFormat;
      o.altFormat = t.noCalendar || u ? "h:i" + (t.enableSeconds ? ":S K" : " K") : h + (" h:i" + (t.enableSeconds ? ":S" : "") + " K");
    }
    Object.defineProperty(e.config, "minDate", {
      get: function() {
        return e.config._minDate;
      },
      set: Ae("min")
    }), Object.defineProperty(e.config, "maxDate", {
      get: function() {
        return e.config._maxDate;
      },
      set: Ae("max")
    });
    var I = function(S) {
      return function(G) {
        e.config[S === "min" ? "_minTime" : "_maxTime"] = e.parseDate(G, "H:i:S");
      };
    };
    Object.defineProperty(e.config, "minTime", {
      get: function() {
        return e.config._minTime;
      },
      set: I("min")
    }), Object.defineProperty(e.config, "maxTime", {
      get: function() {
        return e.config._maxTime;
      },
      set: I("max")
    }), t.mode === "time" && (e.config.noCalendar = !0, e.config.enableTime = !0), Object.assign(e.config, o, t);
    for (var M = 0; M < n.length; M++)
      e.config[n[M]] = e.config[n[M]] === !0 || e.config[n[M]] === "true";
    In.filter(function(S) {
      return e.config[S] !== void 0;
    }).forEach(function(S) {
      e.config[S] = An(e.config[S] || []).map(E);
    }), e.isMobile = !e.config.disableMobile && !e.config.inline && e.config.mode === "single" && !e.config.disable.length && !e.config.enable && !e.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    for (var M = 0; M < e.config.plugins.length; M++) {
      var j = e.config.plugins[M](e) || {};
      for (var w in j)
        In.indexOf(w) > -1 ? e.config[w] = An(j[w]).map(E).concat(e.config[w]) : typeof t[w] > "u" && (e.config[w] = j[w]);
    }
    t.altInputClass || (e.config.altInputClass = Ze().className + " " + e.config.altInputClass), ne("onParseConfig");
  }
  function Ze() {
    return e.config.wrap ? r.querySelector("[data-input]") : r;
  }
  function Qe() {
    typeof e.config.locale != "object" && typeof ue.l10ns[e.config.locale] > "u" && e.config.errorHandler(new Error("flatpickr: invalid locale " + e.config.locale)), e.l10n = pe(pe({}, ue.l10ns.default), typeof e.config.locale == "object" ? e.config.locale : e.config.locale !== "default" ? ue.l10ns[e.config.locale] : void 0), Ve.D = "(" + e.l10n.weekdays.shorthand.join("|") + ")", Ve.l = "(" + e.l10n.weekdays.longhand.join("|") + ")", Ve.M = "(" + e.l10n.months.shorthand.join("|") + ")", Ve.F = "(" + e.l10n.months.longhand.join("|") + ")", Ve.K = "(" + e.l10n.amPM[0] + "|" + e.l10n.amPM[1] + "|" + e.l10n.amPM[0].toLowerCase() + "|" + e.l10n.amPM[1].toLowerCase() + ")";
    var n = pe(pe({}, i), JSON.parse(JSON.stringify(r.dataset || {})));
    n.time_24hr === void 0 && ue.defaultConfig.time_24hr === void 0 && (e.config.time_24hr = e.l10n.time_24hr), e.formatDate = ct(e), e.parseDate = Wn({ config: e.config, l10n: e.l10n });
  }
  function Fe(n) {
    if (typeof e.config.position == "function")
      return void e.config.position(e, n);
    if (e.calendarContainer !== void 0) {
      ne("onPreCalendarPosition");
      var t = n || e._positionElement, o = Array.prototype.reduce.call(e.calendarContainer.children, function(ae, be) {
        return ae + be.offsetHeight;
      }, 0), u = e.calendarContainer.offsetWidth, d = e.config.position.split(" "), h = d[0], I = d.length > 1 ? d[1] : null, M = t.getBoundingClientRect(), j = window.innerHeight - M.bottom, w = h === "above" || h !== "below" && j < o && M.top > o, S = window.pageYOffset + M.top + (w ? -o - 2 : t.offsetHeight + 2);
      if (ve(e.calendarContainer, "arrowTop", !w), ve(e.calendarContainer, "arrowBottom", w), !e.config.inline) {
        var G = window.pageXOffset + M.left, Se = !1, me = !1;
        I === "center" ? (G -= (u - M.width) / 2, Se = !0) : I === "right" && (G -= u - M.width, me = !0), ve(e.calendarContainer, "arrowLeft", !Se && !me), ve(e.calendarContainer, "arrowCenter", Se), ve(e.calendarContainer, "arrowRight", me);
        var a = window.document.body.offsetWidth - (window.pageXOffset + M.right), s = G + u > window.document.body.offsetWidth, g = a + u > window.document.body.offsetWidth;
        if (ve(e.calendarContainer, "rightMost", s), !e.config.static)
          if (e.calendarContainer.style.top = S + "px", !s)
            e.calendarContainer.style.left = G + "px", e.calendarContainer.style.right = "auto";
          else if (!g)
            e.calendarContainer.style.left = "auto", e.calendarContainer.style.right = a + "px";
          else {
            var _ = Dn();
            if (_ === void 0)
              return;
            var V = window.document.body.offsetWidth, X = Math.max(0, V / 2 - u / 2), U = ".flatpickr-calendar.centerMost:before", $ = ".flatpickr-calendar.centerMost:after", ce = _.cssRules.length, re = "{left:" + M.left + "px;right:auto;}";
            ve(e.calendarContainer, "rightMost", !1), ve(e.calendarContainer, "centerMost", !0), _.insertRule(U + "," + $ + re, ce), e.calendarContainer.style.left = X + "px", e.calendarContainer.style.right = "auto";
          }
      }
    }
  }
  function Dn() {
    for (var n = null, t = 0; t < document.styleSheets.length; t++) {
      var o = document.styleSheets[t];
      if (o.cssRules) {
        try {
          o.cssRules;
        } catch {
          continue;
        }
        n = o;
        break;
      }
    }
    return n ?? Cn();
  }
  function Cn() {
    var n = document.createElement("style");
    return document.head.appendChild(n), n.sheet;
  }
  function Be() {
    e.config.noCalendar || e.isMobile || (oe(), He(), ke());
  }
  function en() {
    e._input.focus(), window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0 ? setTimeout(e.close, 0) : e.close();
  }
  function dn(n) {
    n.preventDefault(), n.stopPropagation();
    var t = function(S) {
      return S.classList && S.classList.contains("flatpickr-day") && !S.classList.contains("flatpickr-disabled") && !S.classList.contains("notAllowed");
    }, o = ft(we(n), t);
    if (o !== void 0) {
      var u = o, d = e.latestSelectedDateObj = new Date(u.dateObj.getTime()), h = (d.getMonth() < e.currentMonth || d.getMonth() > e.currentMonth + e.config.showMonths - 1) && e.config.mode !== "range";
      if (e.selectedDateElem = u, e.config.mode === "single")
        e.selectedDates = [d];
      else if (e.config.mode === "multiple") {
        var I = an(d);
        I ? e.selectedDates.splice(parseInt(I), 1) : e.selectedDates.push(d);
      } else
        e.config.mode === "range" && (e.selectedDates.length === 2 && e.clear(!1, !1), e.latestSelectedDateObj = d, e.selectedDates.push(d), Ee(d, e.selectedDates[0], !0) !== 0 && e.selectedDates.sort(function(S, G) {
          return S.getTime() - G.getTime();
        }));
      if (x(), h) {
        var M = e.currentYear !== d.getFullYear();
        e.currentYear = d.getFullYear(), e.currentMonth = d.getMonth(), M && (ne("onYearChange"), oe()), ne("onMonthChange");
      }
      if (He(), ke(), de(), !h && e.config.mode !== "range" && e.config.showMonths === 1 ? Me(u) : e.selectedDateElem !== void 0 && e.hourElement === void 0 && e.selectedDateElem && e.selectedDateElem.focus(), e.hourElement !== void 0 && e.hourElement !== void 0 && e.hourElement.focus(), e.config.closeOnSelect) {
        var j = e.config.mode === "single" && !e.config.enableTime, w = e.config.mode === "range" && e.selectedDates.length === 2 && !e.config.enableTime;
        (j || w) && en();
      }
      ee();
    }
  }
  var Ue = {
    locale: [Qe, je],
    showMonths: [_e, m, Ie],
    minDate: [B],
    maxDate: [B],
    positionElement: [mn],
    clickOpens: [
      function() {
        e.config.clickOpens === !0 ? (T(e._input, "focus", e.open), T(e._input, "click", e.open)) : (e._input.removeEventListener("focus", e.open), e._input.removeEventListener("click", e.open));
      }
    ]
  };
  function pn(n, t) {
    if (n !== null && typeof n == "object") {
      Object.assign(e.config, n);
      for (var o in n)
        Ue[o] !== void 0 && Ue[o].forEach(function(u) {
          return u();
        });
    } else
      e.config[n] = t, Ue[n] !== void 0 ? Ue[n].forEach(function(u) {
        return u();
      }) : In.indexOf(n) > -1 && (e.config[n] = An(t));
    e.redraw(), de(!0);
  }
  function Le(n, t) {
    var o = [];
    if (n instanceof Array)
      o = n.map(function(u) {
        return e.parseDate(u, t);
      });
    else if (n instanceof Date || typeof n == "number")
      o = [e.parseDate(n, t)];
    else if (typeof n == "string")
      switch (e.config.mode) {
        case "single":
        case "time":
          o = [e.parseDate(n, t)];
          break;
        case "multiple":
          o = n.split(e.config.conjunction).map(function(u) {
            return e.parseDate(u, t);
          });
          break;
        case "range":
          o = n.split(e.l10n.rangeSeparator).map(function(u) {
            return e.parseDate(u, t);
          });
          break;
      }
    else
      e.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(n)));
    e.selectedDates = e.config.allowInvalidPreload ? o : o.filter(function(u) {
      return u instanceof Date && k(u, !1);
    }), e.config.mode === "range" && e.selectedDates.sort(function(u, d) {
      return u.getTime() - d.getTime();
    });
  }
  function wn(n, t, o) {
    if (t === void 0 && (t = !1), o === void 0 && (o = e.config.dateFormat), n !== 0 && !n || n instanceof Array && n.length === 0)
      return e.clear(t);
    Le(n, o), e.latestSelectedDateObj = e.selectedDates[e.selectedDates.length - 1], e.redraw(), B(void 0, t), L(), e.selectedDates.length === 0 && e.clear(!1), de(t), t && ne("onChange");
  }
  function nn(n) {
    return n.slice().map(function(t) {
      return typeof t == "string" || typeof t == "number" || t instanceof Date ? e.parseDate(t, void 0, !0) : t && typeof t == "object" && t.from && t.to ? {
        from: e.parseDate(t.from, void 0),
        to: e.parseDate(t.to, void 0)
      } : t;
    }).filter(function(t) {
      return t;
    });
  }
  function gn() {
    e.selectedDates = [], e.now = e.parseDate(e.config.now) || /* @__PURE__ */ new Date();
    var n = e.config.defaultDate || ((e.input.nodeName === "INPUT" || e.input.nodeName === "TEXTAREA") && e.input.placeholder && e.input.value === e.input.placeholder ? null : e.input.value);
    n && Le(n, e.config.dateFormat), e._initialDate = e.selectedDates.length > 0 ? e.selectedDates[0] : e.config.minDate && e.config.minDate.getTime() > e.now.getTime() ? e.config.minDate : e.config.maxDate && e.config.maxDate.getTime() < e.now.getTime() ? e.config.maxDate : e.now, e.currentYear = e._initialDate.getFullYear(), e.currentMonth = e._initialDate.getMonth(), e.selectedDates.length > 0 && (e.latestSelectedDateObj = e.selectedDates[0]), e.config.minTime !== void 0 && (e.config.minTime = e.parseDate(e.config.minTime, "H:i")), e.config.maxTime !== void 0 && (e.config.maxTime = e.parseDate(e.config.maxTime, "H:i")), e.minDateHasTime = !!e.config.minDate && (e.config.minDate.getHours() > 0 || e.config.minDate.getMinutes() > 0 || e.config.minDate.getSeconds() > 0), e.maxDateHasTime = !!e.config.maxDate && (e.config.maxDate.getHours() > 0 || e.config.maxDate.getMinutes() > 0 || e.config.maxDate.getSeconds() > 0);
  }
  function tn() {
    if (e.input = Ze(), !e.input) {
      e.config.errorHandler(new Error("Invalid input element specified"));
      return;
    }
    e.input._type = e.input.type, e.input.type = "text", e.input.classList.add("flatpickr-input"), e._input = e.input, e.config.altInput && (e.altInput = K(e.input.nodeName, e.config.altInputClass), e._input = e.altInput, e.altInput.placeholder = e.input.placeholder, e.altInput.disabled = e.input.disabled, e.altInput.required = e.input.required, e.altInput.tabIndex = e.input.tabIndex, e.altInput.type = "text", e.input.setAttribute("type", "hidden"), !e.config.static && e.input.parentNode && e.input.parentNode.insertBefore(e.altInput, e.input.nextSibling)), e.config.allowInput || e._input.setAttribute("readonly", "readonly"), mn();
  }
  function mn() {
    e._positionElement = e.config.positionElement || e._input;
  }
  function En() {
    var n = e.config.enableTime ? e.config.noCalendar ? "time" : "datetime-local" : "date";
    e.mobileInput = K("input", e.input.className + " flatpickr-mobile"), e.mobileInput.tabIndex = 1, e.mobileInput.type = n, e.mobileInput.disabled = e.input.disabled, e.mobileInput.required = e.input.required, e.mobileInput.placeholder = e.input.placeholder, e.mobileFormatStr = n === "datetime-local" ? "Y-m-d\\TH:i:S" : n === "date" ? "Y-m-d" : "H:i:S", e.selectedDates.length > 0 && (e.mobileInput.defaultValue = e.mobileInput.value = e.formatDate(e.selectedDates[0], e.mobileFormatStr)), e.config.minDate && (e.mobileInput.min = e.formatDate(e.config.minDate, "Y-m-d")), e.config.maxDate && (e.mobileInput.max = e.formatDate(e.config.maxDate, "Y-m-d")), e.input.getAttribute("step") && (e.mobileInput.step = String(e.input.getAttribute("step"))), e.input.type = "hidden", e.altInput !== void 0 && (e.altInput.type = "hidden");
    try {
      e.input.parentNode && e.input.parentNode.insertBefore(e.mobileInput, e.input.nextSibling);
    } catch {
    }
    T(e.mobileInput, "change", function(t) {
      e.setDate(we(t).value, !1, e.mobileFormatStr), ne("onChange"), ne("onClose");
    });
  }
  function Mn(n) {
    if (e.isOpen === !0)
      return e.close();
    e.open(n);
  }
  function ne(n, t) {
    if (e.config !== void 0) {
      var o = e.config[n];
      if (o !== void 0 && o.length > 0)
        for (var u = 0; o[u] && u < o.length; u++)
          o[u](e.selectedDates, e.input.value, e, t);
      n === "onChange" && (e.input.dispatchEvent(rn("change")), e.input.dispatchEvent(rn("input")));
    }
  }
  function rn(n) {
    var t = document.createEvent("Event");
    return t.initEvent(n, !0, !0), t;
  }
  function an(n) {
    for (var t = 0; t < e.selectedDates.length; t++) {
      var o = e.selectedDates[t];
      if (o instanceof Date && Ee(o, n) === 0)
        return "" + t;
    }
    return !1;
  }
  function Tn(n) {
    return e.config.mode !== "range" || e.selectedDates.length < 2 ? !1 : Ee(n, e.selectedDates[0]) >= 0 && Ee(n, e.selectedDates[1]) <= 0;
  }
  function He() {
    e.config.noCalendar || e.isMobile || !e.monthNav || (e.yearElements.forEach(function(n, t) {
      var o = new Date(e.currentYear, e.currentMonth, 1);
      o.setMonth(e.currentMonth + t), e.config.showMonths > 1 || e.config.monthSelectorType === "static" ? e.monthElements[t].textContent = bn(o.getMonth(), e.config.shorthandCurrentMonth, e.l10n) + " " : e.monthsDropdownContainer.value = o.getMonth().toString(), n.value = o.getFullYear().toString();
    }), e._hidePrevMonthArrow = e.config.minDate !== void 0 && (e.currentYear === e.config.minDate.getFullYear() ? e.currentMonth <= e.config.minDate.getMonth() : e.currentYear < e.config.minDate.getFullYear()), e._hideNextMonthArrow = e.config.maxDate !== void 0 && (e.currentYear === e.config.maxDate.getFullYear() ? e.currentMonth + 1 > e.config.maxDate.getMonth() : e.currentYear > e.config.maxDate.getFullYear()));
  }
  function Ke(n) {
    var t = n || (e.config.altInput ? e.config.altFormat : e.config.dateFormat);
    return e.selectedDates.map(function(o) {
      return e.formatDate(o, t);
    }).filter(function(o, u, d) {
      return e.config.mode !== "range" || e.config.enableTime || d.indexOf(o) === u;
    }).join(e.config.mode !== "range" ? e.config.conjunction : e.l10n.rangeSeparator);
  }
  function de(n) {
    n === void 0 && (n = !0), e.mobileInput !== void 0 && e.mobileFormatStr && (e.mobileInput.value = e.latestSelectedDateObj !== void 0 ? e.formatDate(e.latestSelectedDateObj, e.mobileFormatStr) : ""), e.input.value = Ke(e.config.dateFormat), e.altInput !== void 0 && (e.altInput.value = Ke(e.config.altFormat)), n !== !1 && ne("onValueUpdate");
  }
  function on(n) {
    var t = we(n), o = e.prevMonthNav.contains(t), u = e.nextMonthNav.contains(t);
    o || u ? b(o ? -1 : 1) : e.yearElements.indexOf(t) >= 0 ? t.select() : t.classList.contains("arrowUp") ? e.changeYear(e.currentYear + 1) : t.classList.contains("arrowDown") && e.changeYear(e.currentYear - 1);
  }
  function un(n) {
    n.preventDefault();
    var t = n.type === "keydown", o = we(n), u = o;
    e.amPM !== void 0 && o === e.amPM && (e.amPM.textContent = e.l10n.amPM[Oe(e.amPM.textContent === e.l10n.amPM[0])]);
    var d = parseFloat(u.getAttribute("min")), h = parseFloat(u.getAttribute("max")), I = parseFloat(u.getAttribute("step")), M = parseInt(u.value, 10), j = n.delta || (t ? n.which === 38 ? 1 : -1 : 0), w = M + I * j;
    if (typeof u.value < "u" && u.value.length === 2) {
      var S = u === e.hourElement, G = u === e.minuteElement;
      w < d ? (w = h + w + Oe(!S) + (Oe(S) && Oe(!e.amPM)), G && Q(void 0, -1, e.hourElement)) : w > h && (w = u === e.hourElement ? w - h - Oe(!e.amPM) : d, G && Q(void 0, 1, e.hourElement)), e.amPM && S && (I === 1 ? w + M === 23 : Math.abs(w - M) > I) && (e.amPM.textContent = e.l10n.amPM[Oe(e.amPM.textContent === e.l10n.amPM[0])]), u.value = Ce(w);
    }
  }
  return v(), e;
}
function Xe(r, i) {
  for (var e = Array.prototype.slice.call(r).filter(function(E) {
    return E instanceof HTMLElement;
  }), f = [], v = 0; v < e.length; v++) {
    var l = e[v];
    try {
      if (l.getAttribute("data-fp-omit") !== null)
        continue;
      l._flatpickr !== void 0 && (l._flatpickr.destroy(), l._flatpickr = void 0), l._flatpickr = At(l, i || {}), f.push(l._flatpickr);
    } catch (E) {
      console.error(E);
    }
  }
  return f.length === 1 ? f[0] : f;
}
typeof HTMLElement < "u" && typeof HTMLCollection < "u" && typeof NodeList < "u" && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(r) {
  return Xe(this, r);
}, HTMLElement.prototype.flatpickr = function(r) {
  return Xe([this], r);
});
var ue = function(r, i) {
  return typeof r == "string" ? Xe(window.document.querySelectorAll(r), i) : r instanceof Node ? Xe([r], i) : Xe(r, i);
};
ue.defaultConfig = {};
ue.l10ns = {
  en: pe({}, ln),
  default: pe({}, ln)
};
ue.localize = function(r) {
  ue.l10ns.default = pe(pe({}, ue.l10ns.default), r);
};
ue.setDefaults = function(r) {
  ue.defaultConfig = pe(pe({}, ue.defaultConfig), r);
};
ue.parseDate = Wn({});
ue.formatDate = ct({});
ue.compareDates = Ee;
typeof jQuery < "u" && typeof jQuery.fn < "u" && (jQuery.fn.flatpickr = function(r) {
  return Xe(this, r);
});
Date.prototype.fp_incr = function(r) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof r == "string" ? parseInt(r, 10) : r));
};
typeof window < "u" && (window.flatpickr = ue);
const $n = [
  "onChange",
  "onOpen",
  "onClose",
  "onMonthChange",
  "onYearChange",
  "onReady",
  "onValueUpdate",
  "onDayCreate"
], We = he.oneOfType([
  he.func,
  he.arrayOf(he.func)
]), jt = [
  "onCreate",
  "onDestroy"
], at = he.func;
class it extends mt {
  constructor() {
    super(...arguments);
    ze(this, "createFlatpickrInstance", () => {
      let e = {
        onClose: () => {
          this.node.blur && this.node.blur();
        },
        ...this.props.options
      };
      e = Nn(e, this.props), this.flatpickr = ue(this.node, e), this.props.hasOwnProperty("value") && this.flatpickr.setDate(this.props.value, !1);
      const { onCreate: f } = this.props;
      f && f(this.flatpickr);
    });
    ze(this, "destroyFlatpickrInstance", () => {
      const { onDestroy: e } = this.props;
      e && e(this.flatpickr), this.flatpickr && this.flatpickr.destroy(), this.flatpickr = null;
    });
    ze(this, "handleNodeChange", (e) => {
      this.node = e, this.flatpickr && (this.destroyFlatpickrInstance(), this.createFlatpickrInstance());
    });
  }
  componentDidUpdate(e) {
    let { options: f } = this.props, v = e.options;
    f = Nn(f, this.props), v = Nn(v, e);
    const l = Object.getOwnPropertyNames(f);
    for (let E = l.length - 1; E >= 0; E--) {
      const m = l[E];
      let D = f[m];
      D !== v[m] && ($n.indexOf(m) !== -1 && !Array.isArray(D) && (D = [D]), this.flatpickr.set(m, D));
    }
    this.props.hasOwnProperty("value") && !(this.props.value && Array.isArray(this.props.value) && e.value && Array.isArray(e.value) && this.props.value.every((E, m) => {
      e[m];
    })) && this.props.value !== e.value && this.flatpickr.setDate(this.props.value, !1);
  }
  componentDidMount() {
    this.createFlatpickrInstance();
  }
  componentWillUnmount() {
    this.destroyFlatpickrInstance();
  }
  render() {
    const { options: e, defaultValue: f, value: v, children: l, render: E, ...m } = this.props;
    return $n.forEach((D) => {
      delete m[D];
    }), jt.forEach((D) => {
      delete m[D];
    }), E ? E({ ...m, defaultValue: f, value: v }, this.handleNodeChange) : e.wrap ? /* @__PURE__ */ Bn("div", { ...m, ref: this.handleNodeChange, children: l }) : /* @__PURE__ */ Bn("input", { ...m, defaultValue: f, ref: this.handleNodeChange });
  }
}
ze(it, "propTypes", {
  defaultValue: he.string,
  options: he.object,
  onChange: We,
  onOpen: We,
  onClose: We,
  onMonthChange: We,
  onYearChange: We,
  onReady: We,
  onValueUpdate: We,
  onDayCreate: We,
  onCreate: at,
  onDestroy: at,
  value: he.oneOfType([
    he.string,
    he.array,
    he.object,
    he.number
  ]),
  children: he.node,
  className: he.string,
  render: he.func
}), ze(it, "defaultProps", {
  options: {}
});
function Nn(r, i) {
  const e = { ...r };
  return $n.forEach((f) => {
    if (i.hasOwnProperty(f)) {
      e[f] && !Array.isArray(e[f]) ? e[f] = [e[f]] : e[f] || (e[f] = []);
      const v = Array.isArray(i[f]) ? i[f] : [i[f]];
      e[f].push(...v);
    }
  }), e;
}
export {
  it as default
};
